/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as ClientRouteImport } from './routes/client'
import { Route as AppRouteImport } from './routes/app'
import { Route as StaffFullscreenRouteImport } from './routes/_staff-fullscreen'
import { Route as OrgRouteImport } from './routes/_org'
import { Route as ClientFullscreenRouteImport } from './routes/_client-fullscreen'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VerifyEmailIndexRouteImport } from './routes/verify-email/index'
import { Route as ResetPasswordIndexRouteImport } from './routes/reset-password/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as InviteIndexRouteImport } from './routes/invite/index'
import { Route as ForgotPasswordIndexRouteImport } from './routes/forgot-password/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as SsoSlugRouteImport } from './routes/sso/$slug'
import { Route as ResetPasswordConfirmRouteImport } from './routes/reset-password/confirm'
import { Route as LoginMfaSetupRouteImport } from './routes/login/mfa-setup'
import { Route as LoginMfaRouteImport } from './routes/login/mfa'
import { Route as InviteAcceptRouteImport } from './routes/invite/accept'
import { Route as ForgotPasswordSentRouteImport } from './routes/forgot-password/sent'
import { Route as ClientLoginRouteImport } from './routes/client_/login'
import { Route as ClientProfileRouteImport } from './routes/client/profile'
import { Route as ClientDashboardRouteImport } from './routes/client/dashboard'
import { Route as ClientCallNowRouteImport } from './routes/client/call-now'
import { Route as ClientRegisterIndexRouteImport } from './routes/client_/register/index'
import { Route as ClientOnboardingIndexRouteImport } from './routes/client_/onboarding/index'
import { Route as ClientForgotPasswordIndexRouteImport } from './routes/client_/forgot-password/index'
import { Route as ClientSessionsIndexRouteImport } from './routes/client/sessions/index'
import { Route as ClientLibraryIndexRouteImport } from './routes/client/library/index'
import { Route as ClientExercisesIndexRouteImport } from './routes/client/exercises/index'
import { Route as ClientChatIndexRouteImport } from './routes/client/chat/index'
import { Route as ClientBookIndexRouteImport } from './routes/client/book/index'
import { Route as ClientAssessmentsIndexRouteImport } from './routes/client/assessments/index'
import { Route as AppTelephonyIndexRouteImport } from './routes/app/telephony/index'
import { Route as AppSessionsIndexRouteImport } from './routes/app/sessions/index'
import { Route as AppRedFlagsIndexRouteImport } from './routes/app/red-flags/index'
import { Route as AppProfileIndexRouteImport } from './routes/app/profile/index'
import { Route as AppHelplineDemandIndexRouteImport } from './routes/app/helpline-demand/index'
import { Route as AppExercisesIndexRouteImport } from './routes/app/exercises/index'
import { Route as AppClientsIndexRouteImport } from './routes/app/clients/index'
import { Route as AppChatIndexRouteImport } from './routes/app/chat/index'
import { Route as AppCalendarIndexRouteImport } from './routes/app/calendar/index'
import { Route as AppAvailabilityIndexRouteImport } from './routes/app/availability/index'
import { Route as AppAssessmentsIndexRouteImport } from './routes/app/assessments/index'
import { Route as ClientRegisterSentRouteImport } from './routes/client_/register/sent'
import { Route as ClientForgotPasswordSentRouteImport } from './routes/client_/forgot-password/sent'
import { Route as ClientSessionsSessionIdRouteImport } from './routes/client/sessions/$sessionId'
import { Route as ClientLibraryBookmarksRouteImport } from './routes/client/library/bookmarks'
import { Route as ClientLibraryResourceIdRouteImport } from './routes/client/library/$resourceId'
import { Route as ClientExercisesClientExerciseIdRouteImport } from './routes/client/exercises/$clientExerciseId'
import { Route as ClientChatChatIdRouteImport } from './routes/client/chat/$chatId'
import { Route as ClientBookWhenRouteImport } from './routes/client/book/when'
import { Route as ClientBookPractitionerRouteImport } from './routes/client/book/practitioner'
import { Route as ClientBookDetailsRouteImport } from './routes/client/book/details'
import { Route as ClientBookConfirmRouteImport } from './routes/client/book/confirm'
import { Route as AuthSsoLandRouteImport } from './routes/auth/sso/land'
import { Route as AppSessionsHelplineRouteImport } from './routes/app/sessions/helpline'
import { Route as AppSessionsBookRouteImport } from './routes/app/sessions/book'
import { Route as AppSessionsSessionIdRouteImport } from './routes/app/sessions/$sessionId'
import { Route as AppRedFlagsIdRouteImport } from './routes/app/red-flags/$id'
import { Route as AppProfileEditRouteImport } from './routes/app/profile/edit'
import { Route as AppExercisesReviewQueueRouteImport } from './routes/app/exercises/review-queue'
import { Route as AppExercisesIdRouteImport } from './routes/app/exercises/$id'
import { Route as AppClientsClientIdRouteImport } from './routes/app/clients/$clientId'
import { Route as AppChatChatIdRouteImport } from './routes/app/chat/$chatId'
import { Route as AppCaseReportsReviewQueueRouteImport } from './routes/app/case-reports/review-queue'
import { Route as AppAssessmentsTemplateIdRouteImport } from './routes/app/assessments/$templateId'
import { Route as StaffAdminWorkspaceRouteImport } from './routes/_staff/admin/workspace'
import { Route as StaffAdminPlatformRouteImport } from './routes/_staff/admin/platform'
import { Route as AppEngagementResourcesIndexRouteImport } from './routes/app/engagement/resources/index'
import { Route as AppClientsClientIdIndexRouteImport } from './routes/app/clients/$clientId.index'
import { Route as AppAssessmentsAssignmentsIndexRouteImport } from './routes/app/assessments/assignments/index'
import { Route as AppAssessmentsTemplateIdIndexRouteImport } from './routes/app/assessments/$templateId.index'
import { Route as StaffAdminWorkspaceIndexRouteImport } from './routes/_staff/admin/workspace/index'
import { Route as StaffAdminPlatformIndexRouteImport } from './routes/_staff/admin/platform/index'
import { Route as OrgOrgPortalIndexRouteImport } from './routes/_org/org/portal/index'
import { Route as ClientBookSuccessSessionIdRouteImport } from './routes/client/book/success.$sessionId'
import { Route as ClientAssessmentsAssessmentIdAssignmentIdRouteImport } from './routes/client/assessments/$assessmentId.$assignmentId'
import { Route as AppSessionsSessionIdNoteRouteImport } from './routes/app/sessions/$sessionId.note'
import { Route as AppEngagementResourcesIdRouteImport } from './routes/app/engagement/resources/$id'
import { Route as AppAssessmentsAssignmentsAssignmentIdRouteImport } from './routes/app/assessments/assignments/$assignmentId'
import { Route as AppAssessmentsTemplateIdBulkAssignRouteImport } from './routes/app/assessments/$templateId.bulk-assign'
import { Route as AppAssessmentsTemplateIdAssignRouteImport } from './routes/app/assessments/$templateId.assign'
import { Route as OrgOrgPortalStatisticsRouteImport } from './routes/_org/org/portal/statistics'
import { Route as OrgOrgPortalDashboardRouteImport } from './routes/_org/org/portal/dashboard'
import { Route as OrgOrgPortalComplianceRouteImport } from './routes/_org/org/portal/compliance'
import { Route as ClientAssessmentsAssessmentIdAssignmentIdIndexRouteImport } from './routes/client/assessments/$assessmentId.$assignmentId.index'
import { Route as StaffAdminWorkspaceUsersIndexRouteImport } from './routes/_staff/admin/workspace/users/index'
import { Route as StaffAdminWorkspaceTelephonyIndexRouteImport } from './routes/_staff/admin/workspace/telephony/index'
import { Route as StaffAdminWorkspaceSessionsIndexRouteImport } from './routes/_staff/admin/workspace/sessions/index'
import { Route as StaffAdminWorkspaceRedFlagsIndexRouteImport } from './routes/_staff/admin/workspace/red-flags/index'
import { Route as StaffAdminWorkspacePractitionersIndexRouteImport } from './routes/_staff/admin/workspace/practitioners/index'
import { Route as StaffAdminWorkspaceOrganizationsIndexRouteImport } from './routes/_staff/admin/workspace/organizations/index'
import { Route as StaffAdminWorkspaceHelplineDemandIndexRouteImport } from './routes/_staff/admin/workspace/helpline-demand/index'
import { Route as StaffAdminWorkspaceExercisesIndexRouteImport } from './routes/_staff/admin/workspace/exercises/index'
import { Route as StaffAdminWorkspaceClientsIndexRouteImport } from './routes/_staff/admin/workspace/clients/index'
import { Route as StaffAdminWorkspaceChatsIndexRouteImport } from './routes/_staff/admin/workspace/chats/index'
import { Route as StaffAdminWorkspaceAssessmentsIndexRouteImport } from './routes/_staff/admin/workspace/assessments/index'
import { Route as StaffAdminPlatformUsersIndexRouteImport } from './routes/_staff/admin/platform/users/index'
import { Route as StaffAdminPlatformSessionsIndexRouteImport } from './routes/_staff/admin/platform/sessions/index'
import { Route as StaffAdminPlatformRedFlagsIndexRouteImport } from './routes/_staff/admin/platform/red-flags/index'
import { Route as StaffAdminPlatformPractitionersIndexRouteImport } from './routes/_staff/admin/platform/practitioners/index'
import { Route as StaffAdminPlatformOrganizationsIndexRouteImport } from './routes/_staff/admin/platform/organizations/index'
import { Route as StaffAdminPlatformClientsIndexRouteImport } from './routes/_staff/admin/platform/clients/index'
import { Route as StaffAdminPlatformBusinessAssociatesIndexRouteImport } from './routes/_staff/admin/platform/business-associates/index'
import { Route as StaffAdminPlatformAssessmentsIndexRouteImport } from './routes/_staff/admin/platform/assessments/index'
import { Route as ClientAssessmentsAssessmentIdAssignmentIdResultRouteImport } from './routes/client/assessments/$assessmentId.$assignmentId.result'
import { Route as AppSessionsSessionIdCaseReportsNewRouteImport } from './routes/app/sessions/$sessionId.case-reports.new'
import { Route as AppSessionsSessionIdCaseReportsReportIdRouteImport } from './routes/app/sessions/$sessionId.case-reports.$reportId'
import { Route as AppClientsClientIdExercisesClientExerciseIdRouteImport } from './routes/app/clients/$clientId.exercises.$clientExerciseId'
import { Route as StaffAdminWorkspaceUsersInviteRouteImport } from './routes/_staff/admin/workspace/users/invite'
import { Route as StaffAdminWorkspaceUsersUserIdRouteImport } from './routes/_staff/admin/workspace/users/$userId'
import { Route as StaffAdminWorkspaceTelephonyDidMappingsRouteImport } from './routes/_staff/admin/workspace/telephony/did-mappings'
import { Route as StaffAdminWorkspaceTelephonyAgentsRouteImport } from './routes/_staff/admin/workspace/telephony/agents'
import { Route as StaffAdminWorkspaceSessionsBookRouteImport } from './routes/_staff/admin/workspace/sessions/book'
import { Route as StaffAdminWorkspaceSessionsSessionIdRouteImport } from './routes/_staff/admin/workspace/sessions/$sessionId'
import { Route as StaffAdminWorkspaceRedFlagsIdRouteImport } from './routes/_staff/admin/workspace/red-flags/$id'
import { Route as StaffAdminWorkspacePractitionersPractitionerIdRouteImport } from './routes/_staff/admin/workspace/practitioners/$practitionerId'
import { Route as StaffAdminWorkspaceOrganizationsNewRouteImport } from './routes/_staff/admin/workspace/organizations/new'
import { Route as StaffAdminWorkspaceOrganizationsOrgIdRouteImport } from './routes/_staff/admin/workspace/organizations/$orgId'
import { Route as StaffAdminWorkspaceExercisesNewRouteImport } from './routes/_staff/admin/workspace/exercises/new'
import { Route as StaffAdminWorkspaceExercisesIdRouteImport } from './routes/_staff/admin/workspace/exercises/$id'
import { Route as StaffAdminWorkspaceClientsClientIdRouteImport } from './routes/_staff/admin/workspace/clients/$clientId'
import { Route as StaffAdminWorkspaceAssessmentsNewRouteImport } from './routes/_staff/admin/workspace/assessments/new'
import { Route as StaffAdminWorkspaceAssessmentsTemplateIdRouteImport } from './routes/_staff/admin/workspace/assessments/$templateId'
import { Route as StaffAdminPlatformUsersUserIdRouteImport } from './routes/_staff/admin/platform/users/$userId'
import { Route as StaffAdminPlatformTelephonyDidMappingsRouteImport } from './routes/_staff/admin/platform/telephony/did-mappings'
import { Route as StaffAdminPlatformTelephonyAgentsRouteImport } from './routes/_staff/admin/platform/telephony/agents'
import { Route as StaffAdminPlatformSessionsSessionIdRouteImport } from './routes/_staff/admin/platform/sessions/$sessionId'
import { Route as StaffAdminPlatformPractitionersPractitionerIdRouteImport } from './routes/_staff/admin/platform/practitioners/$practitionerId'
import { Route as StaffAdminPlatformOrganizationsOrgIdRouteImport } from './routes/_staff/admin/platform/organizations/$orgId'
import { Route as StaffAdminPlatformClientsClientIdRouteImport } from './routes/_staff/admin/platform/clients/$clientId'
import { Route as StaffAdminPlatformBusinessAssociatesNewRouteImport } from './routes/_staff/admin/platform/business-associates/new'
import { Route as StaffAdminPlatformBusinessAssociatesBaIdRouteImport } from './routes/_staff/admin/platform/business-associates/$baId'
import { Route as StaffAdminPlatformAssessmentsTemplateIdRouteImport } from './routes/_staff/admin/platform/assessments/$templateId'
import { Route as StaffFullscreenAppSessionsSessionIdCallRouteImport } from './routes/_staff-fullscreen/app/sessions/$sessionId.call'
import { Route as ClientFullscreenClientSessionsSessionIdCallRouteImport } from './routes/_client-fullscreen/client/sessions/$sessionId.call'
import { Route as StaffAdminWorkspacePractitionersPractitionerIdIndexRouteImport } from './routes/_staff/admin/workspace/practitioners/$practitionerId.index'
import { Route as StaffAdminWorkspaceOrganizationsOrgIdIndexRouteImport } from './routes/_staff/admin/workspace/organizations/$orgId.index'
import { Route as StaffAdminWorkspaceExercisesIdIndexRouteImport } from './routes/_staff/admin/workspace/exercises/$id.index'
import { Route as StaffAdminWorkspaceEngagementResourcesIndexRouteImport } from './routes/_staff/admin/workspace/engagement/resources/index'
import { Route as StaffAdminWorkspaceClientsClientIdIndexRouteImport } from './routes/_staff/admin/workspace/clients/$clientId.index'
import { Route as StaffAdminWorkspaceAssessmentsAssignmentsIndexRouteImport } from './routes/_staff/admin/workspace/assessments/assignments/index'
import { Route as StaffAdminWorkspaceAssessmentsTemplateIdIndexRouteImport } from './routes/_staff/admin/workspace/assessments/$templateId.index'
import { Route as StaffAdminPlatformBusinessAssociatesBaIdIndexRouteImport } from './routes/_staff/admin/platform/business-associates/$baId.index'
import { Route as StaffAdminPlatformAssessmentsAssignmentsIndexRouteImport } from './routes/_staff/admin/platform/assessments/assignments/index'
import { Route as StaffAdminPlatformAssessmentsTemplateIdIndexRouteImport } from './routes/_staff/admin/platform/assessments/$templateId.index'
import { Route as StaffAdminWorkspaceSessionsSessionIdNoteRouteImport } from './routes/_staff/admin/workspace/sessions/$sessionId.note'
import { Route as StaffAdminWorkspacePractitionersPractitionerIdEditRouteImport } from './routes/_staff/admin/workspace/practitioners/$practitionerId.edit'
import { Route as StaffAdminWorkspaceOrganizationsOrgIdEditRouteImport } from './routes/_staff/admin/workspace/organizations/$orgId.edit'
import { Route as StaffAdminWorkspaceExercisesIdEditRouteImport } from './routes/_staff/admin/workspace/exercises/$id.edit'
import { Route as StaffAdminWorkspaceEngagementResourcesNewRouteImport } from './routes/_staff/admin/workspace/engagement/resources/new'
import { Route as StaffAdminWorkspaceEngagementResourcesIdRouteImport } from './routes/_staff/admin/workspace/engagement/resources/$id'
import { Route as StaffAdminWorkspaceClientsClientIdEditRouteImport } from './routes/_staff/admin/workspace/clients/$clientId.edit'
import { Route as StaffAdminWorkspaceAssessmentsAssignmentsAssignmentIdRouteImport } from './routes/_staff/admin/workspace/assessments/assignments/$assignmentId'
import { Route as StaffAdminWorkspaceAssessmentsTemplateIdBulkAssignRouteImport } from './routes/_staff/admin/workspace/assessments/$templateId.bulk-assign'
import { Route as StaffAdminWorkspaceAssessmentsTemplateIdAssignRouteImport } from './routes/_staff/admin/workspace/assessments/$templateId.assign'
import { Route as StaffAdminPlatformBusinessAssociatesBaIdEditRouteImport } from './routes/_staff/admin/platform/business-associates/$baId.edit'
import { Route as StaffAdminPlatformAssessmentsAssignmentsAssignmentIdRouteImport } from './routes/_staff/admin/platform/assessments/assignments/$assignmentId'
import { Route as StaffFullscreenAdminWorkspaceSessionsSessionIdCallRouteImport } from './routes/_staff-fullscreen/admin/workspace/sessions/$sessionId.call'
import { Route as StaffAdminWorkspaceEngagementResourcesIdIndexRouteImport } from './routes/_staff/admin/workspace/engagement/resources/$id.index'
import { Route as StaffAdminWorkspaceSessionsSessionIdCaseReportsNewRouteImport } from './routes/_staff/admin/workspace/sessions/$sessionId.case-reports.new'
import { Route as StaffAdminWorkspaceSessionsSessionIdCaseReportsReportIdRouteImport } from './routes/_staff/admin/workspace/sessions/$sessionId.case-reports.$reportId'
import { Route as StaffAdminWorkspaceOrganizationsOrgIdLocationsNewRouteImport } from './routes/_staff/admin/workspace/organizations/$orgId.locations/new'
import { Route as StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRouteImport } from './routes/_staff/admin/workspace/organizations/$orgId.locations/$locId'
import { Route as StaffAdminWorkspaceEngagementResourcesIdEditRouteImport } from './routes/_staff/admin/workspace/engagement/resources/$id.edit'
import { Route as StaffAdminWorkspaceClientsClientIdExercisesClientExerciseIdRouteImport } from './routes/_staff/admin/workspace/clients/$clientId.exercises.$clientExerciseId'
import { Route as StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdIndexRouteImport } from './routes/_staff/admin/workspace/organizations/$orgId.locations/$locId.index'
import { Route as StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdEditRouteImport } from './routes/_staff/admin/workspace/organizations/$orgId.locations/$locId.edit'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientRoute = ClientRouteImport.update({
  id: '/client',
  path: '/client',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffFullscreenRoute = StaffFullscreenRouteImport.update({
  id: '/_staff-fullscreen',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgRoute = OrgRouteImport.update({
  id: '/_org',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientFullscreenRoute = ClientFullscreenRouteImport.update({
  id: '/_client-fullscreen',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailIndexRoute = VerifyEmailIndexRouteImport.update({
  id: '/verify-email/',
  path: '/verify-email/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordIndexRoute = ResetPasswordIndexRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteIndexRoute = InviteIndexRouteImport.update({
  id: '/invite/',
  path: '/invite/',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordIndexRoute = ForgotPasswordIndexRouteImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const SsoSlugRoute = SsoSlugRouteImport.update({
  id: '/sso/$slug',
  path: '/sso/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordConfirmRoute = ResetPasswordConfirmRouteImport.update({
  id: '/reset-password/confirm',
  path: '/reset-password/confirm',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginMfaSetupRoute = LoginMfaSetupRouteImport.update({
  id: '/login/mfa-setup',
  path: '/login/mfa-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginMfaRoute = LoginMfaRouteImport.update({
  id: '/login/mfa',
  path: '/login/mfa',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteAcceptRoute = InviteAcceptRouteImport.update({
  id: '/invite/accept',
  path: '/invite/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordSentRoute = ForgotPasswordSentRouteImport.update({
  id: '/forgot-password/sent',
  path: '/forgot-password/sent',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientLoginRoute = ClientLoginRouteImport.update({
  id: '/client_/login',
  path: '/client/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientProfileRoute = ClientProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ClientRoute,
} as any)
const ClientDashboardRoute = ClientDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ClientRoute,
} as any)
const ClientCallNowRoute = ClientCallNowRouteImport.update({
  id: '/call-now',
  path: '/call-now',
  getParentRoute: () => ClientRoute,
} as any)
const ClientRegisterIndexRoute = ClientRegisterIndexRouteImport.update({
  id: '/client_/register/',
  path: '/client/register/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientOnboardingIndexRoute = ClientOnboardingIndexRouteImport.update({
  id: '/client_/onboarding/',
  path: '/client/onboarding/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientForgotPasswordIndexRoute =
  ClientForgotPasswordIndexRouteImport.update({
    id: '/client_/forgot-password/',
    path: '/client/forgot-password/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ClientSessionsIndexRoute = ClientSessionsIndexRouteImport.update({
  id: '/sessions/',
  path: '/sessions/',
  getParentRoute: () => ClientRoute,
} as any)
const ClientLibraryIndexRoute = ClientLibraryIndexRouteImport.update({
  id: '/library/',
  path: '/library/',
  getParentRoute: () => ClientRoute,
} as any)
const ClientExercisesIndexRoute = ClientExercisesIndexRouteImport.update({
  id: '/exercises/',
  path: '/exercises/',
  getParentRoute: () => ClientRoute,
} as any)
const ClientChatIndexRoute = ClientChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => ClientRoute,
} as any)
const ClientBookIndexRoute = ClientBookIndexRouteImport.update({
  id: '/book/',
  path: '/book/',
  getParentRoute: () => ClientRoute,
} as any)
const ClientAssessmentsIndexRoute = ClientAssessmentsIndexRouteImport.update({
  id: '/assessments/',
  path: '/assessments/',
  getParentRoute: () => ClientRoute,
} as any)
const AppTelephonyIndexRoute = AppTelephonyIndexRouteImport.update({
  id: '/telephony/',
  path: '/telephony/',
  getParentRoute: () => AppRoute,
} as any)
const AppSessionsIndexRoute = AppSessionsIndexRouteImport.update({
  id: '/sessions/',
  path: '/sessions/',
  getParentRoute: () => AppRoute,
} as any)
const AppRedFlagsIndexRoute = AppRedFlagsIndexRouteImport.update({
  id: '/red-flags/',
  path: '/red-flags/',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileIndexRoute = AppProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AppRoute,
} as any)
const AppHelplineDemandIndexRoute = AppHelplineDemandIndexRouteImport.update({
  id: '/helpline-demand/',
  path: '/helpline-demand/',
  getParentRoute: () => AppRoute,
} as any)
const AppExercisesIndexRoute = AppExercisesIndexRouteImport.update({
  id: '/exercises/',
  path: '/exercises/',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppRoute,
} as any)
const AppChatIndexRoute = AppChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarIndexRoute = AppCalendarIndexRouteImport.update({
  id: '/calendar/',
  path: '/calendar/',
  getParentRoute: () => AppRoute,
} as any)
const AppAvailabilityIndexRoute = AppAvailabilityIndexRouteImport.update({
  id: '/availability/',
  path: '/availability/',
  getParentRoute: () => AppRoute,
} as any)
const AppAssessmentsIndexRoute = AppAssessmentsIndexRouteImport.update({
  id: '/assessments/',
  path: '/assessments/',
  getParentRoute: () => AppRoute,
} as any)
const ClientRegisterSentRoute = ClientRegisterSentRouteImport.update({
  id: '/client_/register/sent',
  path: '/client/register/sent',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientForgotPasswordSentRoute =
  ClientForgotPasswordSentRouteImport.update({
    id: '/client_/forgot-password/sent',
    path: '/client/forgot-password/sent',
    getParentRoute: () => rootRouteImport,
  } as any)
const ClientSessionsSessionIdRoute = ClientSessionsSessionIdRouteImport.update({
  id: '/sessions/$sessionId',
  path: '/sessions/$sessionId',
  getParentRoute: () => ClientRoute,
} as any)
const ClientLibraryBookmarksRoute = ClientLibraryBookmarksRouteImport.update({
  id: '/library/bookmarks',
  path: '/library/bookmarks',
  getParentRoute: () => ClientRoute,
} as any)
const ClientLibraryResourceIdRoute = ClientLibraryResourceIdRouteImport.update({
  id: '/library/$resourceId',
  path: '/library/$resourceId',
  getParentRoute: () => ClientRoute,
} as any)
const ClientExercisesClientExerciseIdRoute =
  ClientExercisesClientExerciseIdRouteImport.update({
    id: '/exercises/$clientExerciseId',
    path: '/exercises/$clientExerciseId',
    getParentRoute: () => ClientRoute,
  } as any)
const ClientChatChatIdRoute = ClientChatChatIdRouteImport.update({
  id: '/chat/$chatId',
  path: '/chat/$chatId',
  getParentRoute: () => ClientRoute,
} as any)
const ClientBookWhenRoute = ClientBookWhenRouteImport.update({
  id: '/book/when',
  path: '/book/when',
  getParentRoute: () => ClientRoute,
} as any)
const ClientBookPractitionerRoute = ClientBookPractitionerRouteImport.update({
  id: '/book/practitioner',
  path: '/book/practitioner',
  getParentRoute: () => ClientRoute,
} as any)
const ClientBookDetailsRoute = ClientBookDetailsRouteImport.update({
  id: '/book/details',
  path: '/book/details',
  getParentRoute: () => ClientRoute,
} as any)
const ClientBookConfirmRoute = ClientBookConfirmRouteImport.update({
  id: '/book/confirm',
  path: '/book/confirm',
  getParentRoute: () => ClientRoute,
} as any)
const AuthSsoLandRoute = AuthSsoLandRouteImport.update({
  id: '/auth/sso/land',
  path: '/auth/sso/land',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSessionsHelplineRoute = AppSessionsHelplineRouteImport.update({
  id: '/sessions/helpline',
  path: '/sessions/helpline',
  getParentRoute: () => AppRoute,
} as any)
const AppSessionsBookRoute = AppSessionsBookRouteImport.update({
  id: '/sessions/book',
  path: '/sessions/book',
  getParentRoute: () => AppRoute,
} as any)
const AppSessionsSessionIdRoute = AppSessionsSessionIdRouteImport.update({
  id: '/sessions/$sessionId',
  path: '/sessions/$sessionId',
  getParentRoute: () => AppRoute,
} as any)
const AppRedFlagsIdRoute = AppRedFlagsIdRouteImport.update({
  id: '/red-flags/$id',
  path: '/red-flags/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileEditRoute = AppProfileEditRouteImport.update({
  id: '/profile/edit',
  path: '/profile/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppExercisesReviewQueueRoute = AppExercisesReviewQueueRouteImport.update({
  id: '/exercises/review-queue',
  path: '/exercises/review-queue',
  getParentRoute: () => AppRoute,
} as any)
const AppExercisesIdRoute = AppExercisesIdRouteImport.update({
  id: '/exercises/$id',
  path: '/exercises/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsClientIdRoute = AppClientsClientIdRouteImport.update({
  id: '/clients/$clientId',
  path: '/clients/$clientId',
  getParentRoute: () => AppRoute,
} as any)
const AppChatChatIdRoute = AppChatChatIdRouteImport.update({
  id: '/chat/$chatId',
  path: '/chat/$chatId',
  getParentRoute: () => AppRoute,
} as any)
const AppCaseReportsReviewQueueRoute =
  AppCaseReportsReviewQueueRouteImport.update({
    id: '/case-reports/review-queue',
    path: '/case-reports/review-queue',
    getParentRoute: () => AppRoute,
  } as any)
const AppAssessmentsTemplateIdRoute =
  AppAssessmentsTemplateIdRouteImport.update({
    id: '/assessments/$templateId',
    path: '/assessments/$templateId',
    getParentRoute: () => AppRoute,
  } as any)
const StaffAdminWorkspaceRoute = StaffAdminWorkspaceRouteImport.update({
  id: '/_staff/admin/workspace',
  path: '/admin/workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffAdminPlatformRoute = StaffAdminPlatformRouteImport.update({
  id: '/_staff/admin/platform',
  path: '/admin/platform',
  getParentRoute: () => rootRouteImport,
} as any)
const AppEngagementResourcesIndexRoute =
  AppEngagementResourcesIndexRouteImport.update({
    id: '/engagement/resources/',
    path: '/engagement/resources/',
    getParentRoute: () => AppRoute,
  } as any)
const AppClientsClientIdIndexRoute = AppClientsClientIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppClientsClientIdRoute,
} as any)
const AppAssessmentsAssignmentsIndexRoute =
  AppAssessmentsAssignmentsIndexRouteImport.update({
    id: '/assessments/assignments/',
    path: '/assessments/assignments/',
    getParentRoute: () => AppRoute,
  } as any)
const AppAssessmentsTemplateIdIndexRoute =
  AppAssessmentsTemplateIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAssessmentsTemplateIdRoute,
  } as any)
const StaffAdminWorkspaceIndexRoute =
  StaffAdminWorkspaceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminPlatformIndexRoute = StaffAdminPlatformIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffAdminPlatformRoute,
} as any)
const OrgOrgPortalIndexRoute = OrgOrgPortalIndexRouteImport.update({
  id: '/org/portal/',
  path: '/org/portal/',
  getParentRoute: () => OrgRoute,
} as any)
const ClientBookSuccessSessionIdRoute =
  ClientBookSuccessSessionIdRouteImport.update({
    id: '/book/success/$sessionId',
    path: '/book/success/$sessionId',
    getParentRoute: () => ClientRoute,
  } as any)
const ClientAssessmentsAssessmentIdAssignmentIdRoute =
  ClientAssessmentsAssessmentIdAssignmentIdRouteImport.update({
    id: '/assessments/$assessmentId/$assignmentId',
    path: '/assessments/$assessmentId/$assignmentId',
    getParentRoute: () => ClientRoute,
  } as any)
const AppSessionsSessionIdNoteRoute =
  AppSessionsSessionIdNoteRouteImport.update({
    id: '/note',
    path: '/note',
    getParentRoute: () => AppSessionsSessionIdRoute,
  } as any)
const AppEngagementResourcesIdRoute =
  AppEngagementResourcesIdRouteImport.update({
    id: '/engagement/resources/$id',
    path: '/engagement/resources/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppAssessmentsAssignmentsAssignmentIdRoute =
  AppAssessmentsAssignmentsAssignmentIdRouteImport.update({
    id: '/assessments/assignments/$assignmentId',
    path: '/assessments/assignments/$assignmentId',
    getParentRoute: () => AppRoute,
  } as any)
const AppAssessmentsTemplateIdBulkAssignRoute =
  AppAssessmentsTemplateIdBulkAssignRouteImport.update({
    id: '/bulk-assign',
    path: '/bulk-assign',
    getParentRoute: () => AppAssessmentsTemplateIdRoute,
  } as any)
const AppAssessmentsTemplateIdAssignRoute =
  AppAssessmentsTemplateIdAssignRouteImport.update({
    id: '/assign',
    path: '/assign',
    getParentRoute: () => AppAssessmentsTemplateIdRoute,
  } as any)
const OrgOrgPortalStatisticsRoute = OrgOrgPortalStatisticsRouteImport.update({
  id: '/org/portal/statistics',
  path: '/org/portal/statistics',
  getParentRoute: () => OrgRoute,
} as any)
const OrgOrgPortalDashboardRoute = OrgOrgPortalDashboardRouteImport.update({
  id: '/org/portal/dashboard',
  path: '/org/portal/dashboard',
  getParentRoute: () => OrgRoute,
} as any)
const OrgOrgPortalComplianceRoute = OrgOrgPortalComplianceRouteImport.update({
  id: '/org/portal/compliance',
  path: '/org/portal/compliance',
  getParentRoute: () => OrgRoute,
} as any)
const ClientAssessmentsAssessmentIdAssignmentIdIndexRoute =
  ClientAssessmentsAssessmentIdAssignmentIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ClientAssessmentsAssessmentIdAssignmentIdRoute,
  } as any)
const StaffAdminWorkspaceUsersIndexRoute =
  StaffAdminWorkspaceUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceTelephonyIndexRoute =
  StaffAdminWorkspaceTelephonyIndexRouteImport.update({
    id: '/telephony/',
    path: '/telephony/',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceSessionsIndexRoute =
  StaffAdminWorkspaceSessionsIndexRouteImport.update({
    id: '/sessions/',
    path: '/sessions/',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceRedFlagsIndexRoute =
  StaffAdminWorkspaceRedFlagsIndexRouteImport.update({
    id: '/red-flags/',
    path: '/red-flags/',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspacePractitionersIndexRoute =
  StaffAdminWorkspacePractitionersIndexRouteImport.update({
    id: '/practitioners/',
    path: '/practitioners/',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceOrganizationsIndexRoute =
  StaffAdminWorkspaceOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceHelplineDemandIndexRoute =
  StaffAdminWorkspaceHelplineDemandIndexRouteImport.update({
    id: '/helpline-demand/',
    path: '/helpline-demand/',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceExercisesIndexRoute =
  StaffAdminWorkspaceExercisesIndexRouteImport.update({
    id: '/exercises/',
    path: '/exercises/',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceClientsIndexRoute =
  StaffAdminWorkspaceClientsIndexRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceChatsIndexRoute =
  StaffAdminWorkspaceChatsIndexRouteImport.update({
    id: '/chats/',
    path: '/chats/',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceAssessmentsIndexRoute =
  StaffAdminWorkspaceAssessmentsIndexRouteImport.update({
    id: '/assessments/',
    path: '/assessments/',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminPlatformUsersIndexRoute =
  StaffAdminPlatformUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffAdminPlatformSessionsIndexRoute =
  StaffAdminPlatformSessionsIndexRouteImport.update({
    id: '/sessions/',
    path: '/sessions/',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffAdminPlatformRedFlagsIndexRoute =
  StaffAdminPlatformRedFlagsIndexRouteImport.update({
    id: '/red-flags/',
    path: '/red-flags/',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffAdminPlatformPractitionersIndexRoute =
  StaffAdminPlatformPractitionersIndexRouteImport.update({
    id: '/practitioners/',
    path: '/practitioners/',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffAdminPlatformOrganizationsIndexRoute =
  StaffAdminPlatformOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffAdminPlatformClientsIndexRoute =
  StaffAdminPlatformClientsIndexRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffAdminPlatformBusinessAssociatesIndexRoute =
  StaffAdminPlatformBusinessAssociatesIndexRouteImport.update({
    id: '/business-associates/',
    path: '/business-associates/',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffAdminPlatformAssessmentsIndexRoute =
  StaffAdminPlatformAssessmentsIndexRouteImport.update({
    id: '/assessments/',
    path: '/assessments/',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const ClientAssessmentsAssessmentIdAssignmentIdResultRoute =
  ClientAssessmentsAssessmentIdAssignmentIdResultRouteImport.update({
    id: '/result',
    path: '/result',
    getParentRoute: () => ClientAssessmentsAssessmentIdAssignmentIdRoute,
  } as any)
const AppSessionsSessionIdCaseReportsNewRoute =
  AppSessionsSessionIdCaseReportsNewRouteImport.update({
    id: '/case-reports/new',
    path: '/case-reports/new',
    getParentRoute: () => AppSessionsSessionIdRoute,
  } as any)
const AppSessionsSessionIdCaseReportsReportIdRoute =
  AppSessionsSessionIdCaseReportsReportIdRouteImport.update({
    id: '/case-reports/$reportId',
    path: '/case-reports/$reportId',
    getParentRoute: () => AppSessionsSessionIdRoute,
  } as any)
const AppClientsClientIdExercisesClientExerciseIdRoute =
  AppClientsClientIdExercisesClientExerciseIdRouteImport.update({
    id: '/exercises/$clientExerciseId',
    path: '/exercises/$clientExerciseId',
    getParentRoute: () => AppClientsClientIdRoute,
  } as any)
const StaffAdminWorkspaceUsersInviteRoute =
  StaffAdminWorkspaceUsersInviteRouteImport.update({
    id: '/users/invite',
    path: '/users/invite',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceUsersUserIdRoute =
  StaffAdminWorkspaceUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceTelephonyDidMappingsRoute =
  StaffAdminWorkspaceTelephonyDidMappingsRouteImport.update({
    id: '/telephony/did-mappings',
    path: '/telephony/did-mappings',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceTelephonyAgentsRoute =
  StaffAdminWorkspaceTelephonyAgentsRouteImport.update({
    id: '/telephony/agents',
    path: '/telephony/agents',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceSessionsBookRoute =
  StaffAdminWorkspaceSessionsBookRouteImport.update({
    id: '/sessions/book',
    path: '/sessions/book',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceSessionsSessionIdRoute =
  StaffAdminWorkspaceSessionsSessionIdRouteImport.update({
    id: '/sessions/$sessionId',
    path: '/sessions/$sessionId',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceRedFlagsIdRoute =
  StaffAdminWorkspaceRedFlagsIdRouteImport.update({
    id: '/red-flags/$id',
    path: '/red-flags/$id',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspacePractitionersPractitionerIdRoute =
  StaffAdminWorkspacePractitionersPractitionerIdRouteImport.update({
    id: '/practitioners/$practitionerId',
    path: '/practitioners/$practitionerId',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceOrganizationsNewRoute =
  StaffAdminWorkspaceOrganizationsNewRouteImport.update({
    id: '/organizations/new',
    path: '/organizations/new',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceOrganizationsOrgIdRoute =
  StaffAdminWorkspaceOrganizationsOrgIdRouteImport.update({
    id: '/organizations/$orgId',
    path: '/organizations/$orgId',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceExercisesNewRoute =
  StaffAdminWorkspaceExercisesNewRouteImport.update({
    id: '/exercises/new',
    path: '/exercises/new',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceExercisesIdRoute =
  StaffAdminWorkspaceExercisesIdRouteImport.update({
    id: '/exercises/$id',
    path: '/exercises/$id',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceClientsClientIdRoute =
  StaffAdminWorkspaceClientsClientIdRouteImport.update({
    id: '/clients/$clientId',
    path: '/clients/$clientId',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceAssessmentsNewRoute =
  StaffAdminWorkspaceAssessmentsNewRouteImport.update({
    id: '/assessments/new',
    path: '/assessments/new',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceAssessmentsTemplateIdRoute =
  StaffAdminWorkspaceAssessmentsTemplateIdRouteImport.update({
    id: '/assessments/$templateId',
    path: '/assessments/$templateId',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminPlatformUsersUserIdRoute =
  StaffAdminPlatformUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffAdminPlatformTelephonyDidMappingsRoute =
  StaffAdminPlatformTelephonyDidMappingsRouteImport.update({
    id: '/telephony/did-mappings',
    path: '/telephony/did-mappings',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffAdminPlatformTelephonyAgentsRoute =
  StaffAdminPlatformTelephonyAgentsRouteImport.update({
    id: '/telephony/agents',
    path: '/telephony/agents',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffAdminPlatformSessionsSessionIdRoute =
  StaffAdminPlatformSessionsSessionIdRouteImport.update({
    id: '/sessions/$sessionId',
    path: '/sessions/$sessionId',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffAdminPlatformPractitionersPractitionerIdRoute =
  StaffAdminPlatformPractitionersPractitionerIdRouteImport.update({
    id: '/practitioners/$practitionerId',
    path: '/practitioners/$practitionerId',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffAdminPlatformOrganizationsOrgIdRoute =
  StaffAdminPlatformOrganizationsOrgIdRouteImport.update({
    id: '/organizations/$orgId',
    path: '/organizations/$orgId',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffAdminPlatformClientsClientIdRoute =
  StaffAdminPlatformClientsClientIdRouteImport.update({
    id: '/clients/$clientId',
    path: '/clients/$clientId',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffAdminPlatformBusinessAssociatesNewRoute =
  StaffAdminPlatformBusinessAssociatesNewRouteImport.update({
    id: '/business-associates/new',
    path: '/business-associates/new',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffAdminPlatformBusinessAssociatesBaIdRoute =
  StaffAdminPlatformBusinessAssociatesBaIdRouteImport.update({
    id: '/business-associates/$baId',
    path: '/business-associates/$baId',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffAdminPlatformAssessmentsTemplateIdRoute =
  StaffAdminPlatformAssessmentsTemplateIdRouteImport.update({
    id: '/assessments/$templateId',
    path: '/assessments/$templateId',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffFullscreenAppSessionsSessionIdCallRoute =
  StaffFullscreenAppSessionsSessionIdCallRouteImport.update({
    id: '/app/sessions/$sessionId/call',
    path: '/app/sessions/$sessionId/call',
    getParentRoute: () => StaffFullscreenRoute,
  } as any)
const ClientFullscreenClientSessionsSessionIdCallRoute =
  ClientFullscreenClientSessionsSessionIdCallRouteImport.update({
    id: '/client/sessions/$sessionId/call',
    path: '/client/sessions/$sessionId/call',
    getParentRoute: () => ClientFullscreenRoute,
  } as any)
const StaffAdminWorkspacePractitionersPractitionerIdIndexRoute =
  StaffAdminWorkspacePractitionersPractitionerIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAdminWorkspacePractitionersPractitionerIdRoute,
  } as any)
const StaffAdminWorkspaceOrganizationsOrgIdIndexRoute =
  StaffAdminWorkspaceOrganizationsOrgIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAdminWorkspaceOrganizationsOrgIdRoute,
  } as any)
const StaffAdminWorkspaceExercisesIdIndexRoute =
  StaffAdminWorkspaceExercisesIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAdminWorkspaceExercisesIdRoute,
  } as any)
const StaffAdminWorkspaceEngagementResourcesIndexRoute =
  StaffAdminWorkspaceEngagementResourcesIndexRouteImport.update({
    id: '/engagement/resources/',
    path: '/engagement/resources/',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceClientsClientIdIndexRoute =
  StaffAdminWorkspaceClientsClientIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAdminWorkspaceClientsClientIdRoute,
  } as any)
const StaffAdminWorkspaceAssessmentsAssignmentsIndexRoute =
  StaffAdminWorkspaceAssessmentsAssignmentsIndexRouteImport.update({
    id: '/assessments/assignments/',
    path: '/assessments/assignments/',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceAssessmentsTemplateIdIndexRoute =
  StaffAdminWorkspaceAssessmentsTemplateIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAdminWorkspaceAssessmentsTemplateIdRoute,
  } as any)
const StaffAdminPlatformBusinessAssociatesBaIdIndexRoute =
  StaffAdminPlatformBusinessAssociatesBaIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAdminPlatformBusinessAssociatesBaIdRoute,
  } as any)
const StaffAdminPlatformAssessmentsAssignmentsIndexRoute =
  StaffAdminPlatformAssessmentsAssignmentsIndexRouteImport.update({
    id: '/assessments/assignments/',
    path: '/assessments/assignments/',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffAdminPlatformAssessmentsTemplateIdIndexRoute =
  StaffAdminPlatformAssessmentsTemplateIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAdminPlatformAssessmentsTemplateIdRoute,
  } as any)
const StaffAdminWorkspaceSessionsSessionIdNoteRoute =
  StaffAdminWorkspaceSessionsSessionIdNoteRouteImport.update({
    id: '/note',
    path: '/note',
    getParentRoute: () => StaffAdminWorkspaceSessionsSessionIdRoute,
  } as any)
const StaffAdminWorkspacePractitionersPractitionerIdEditRoute =
  StaffAdminWorkspacePractitionersPractitionerIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => StaffAdminWorkspacePractitionersPractitionerIdRoute,
  } as any)
const StaffAdminWorkspaceOrganizationsOrgIdEditRoute =
  StaffAdminWorkspaceOrganizationsOrgIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => StaffAdminWorkspaceOrganizationsOrgIdRoute,
  } as any)
const StaffAdminWorkspaceExercisesIdEditRoute =
  StaffAdminWorkspaceExercisesIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => StaffAdminWorkspaceExercisesIdRoute,
  } as any)
const StaffAdminWorkspaceEngagementResourcesNewRoute =
  StaffAdminWorkspaceEngagementResourcesNewRouteImport.update({
    id: '/engagement/resources/new',
    path: '/engagement/resources/new',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceEngagementResourcesIdRoute =
  StaffAdminWorkspaceEngagementResourcesIdRouteImport.update({
    id: '/engagement/resources/$id',
    path: '/engagement/resources/$id',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceClientsClientIdEditRoute =
  StaffAdminWorkspaceClientsClientIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => StaffAdminWorkspaceClientsClientIdRoute,
  } as any)
const StaffAdminWorkspaceAssessmentsAssignmentsAssignmentIdRoute =
  StaffAdminWorkspaceAssessmentsAssignmentsAssignmentIdRouteImport.update({
    id: '/assessments/assignments/$assignmentId',
    path: '/assessments/assignments/$assignmentId',
    getParentRoute: () => StaffAdminWorkspaceRoute,
  } as any)
const StaffAdminWorkspaceAssessmentsTemplateIdBulkAssignRoute =
  StaffAdminWorkspaceAssessmentsTemplateIdBulkAssignRouteImport.update({
    id: '/bulk-assign',
    path: '/bulk-assign',
    getParentRoute: () => StaffAdminWorkspaceAssessmentsTemplateIdRoute,
  } as any)
const StaffAdminWorkspaceAssessmentsTemplateIdAssignRoute =
  StaffAdminWorkspaceAssessmentsTemplateIdAssignRouteImport.update({
    id: '/assign',
    path: '/assign',
    getParentRoute: () => StaffAdminWorkspaceAssessmentsTemplateIdRoute,
  } as any)
const StaffAdminPlatformBusinessAssociatesBaIdEditRoute =
  StaffAdminPlatformBusinessAssociatesBaIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => StaffAdminPlatformBusinessAssociatesBaIdRoute,
  } as any)
const StaffAdminPlatformAssessmentsAssignmentsAssignmentIdRoute =
  StaffAdminPlatformAssessmentsAssignmentsAssignmentIdRouteImport.update({
    id: '/assessments/assignments/$assignmentId',
    path: '/assessments/assignments/$assignmentId',
    getParentRoute: () => StaffAdminPlatformRoute,
  } as any)
const StaffFullscreenAdminWorkspaceSessionsSessionIdCallRoute =
  StaffFullscreenAdminWorkspaceSessionsSessionIdCallRouteImport.update({
    id: '/admin/workspace/sessions/$sessionId/call',
    path: '/admin/workspace/sessions/$sessionId/call',
    getParentRoute: () => StaffFullscreenRoute,
  } as any)
const StaffAdminWorkspaceEngagementResourcesIdIndexRoute =
  StaffAdminWorkspaceEngagementResourcesIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAdminWorkspaceEngagementResourcesIdRoute,
  } as any)
const StaffAdminWorkspaceSessionsSessionIdCaseReportsNewRoute =
  StaffAdminWorkspaceSessionsSessionIdCaseReportsNewRouteImport.update({
    id: '/case-reports/new',
    path: '/case-reports/new',
    getParentRoute: () => StaffAdminWorkspaceSessionsSessionIdRoute,
  } as any)
const StaffAdminWorkspaceSessionsSessionIdCaseReportsReportIdRoute =
  StaffAdminWorkspaceSessionsSessionIdCaseReportsReportIdRouteImport.update({
    id: '/case-reports/$reportId',
    path: '/case-reports/$reportId',
    getParentRoute: () => StaffAdminWorkspaceSessionsSessionIdRoute,
  } as any)
const StaffAdminWorkspaceOrganizationsOrgIdLocationsNewRoute =
  StaffAdminWorkspaceOrganizationsOrgIdLocationsNewRouteImport.update({
    id: '/locations/new',
    path: '/locations/new',
    getParentRoute: () => StaffAdminWorkspaceOrganizationsOrgIdRoute,
  } as any)
const StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRoute =
  StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRouteImport.update({
    id: '/locations/$locId',
    path: '/locations/$locId',
    getParentRoute: () => StaffAdminWorkspaceOrganizationsOrgIdRoute,
  } as any)
const StaffAdminWorkspaceEngagementResourcesIdEditRoute =
  StaffAdminWorkspaceEngagementResourcesIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => StaffAdminWorkspaceEngagementResourcesIdRoute,
  } as any)
const StaffAdminWorkspaceClientsClientIdExercisesClientExerciseIdRoute =
  StaffAdminWorkspaceClientsClientIdExercisesClientExerciseIdRouteImport.update(
    {
      id: '/exercises/$clientExerciseId',
      path: '/exercises/$clientExerciseId',
      getParentRoute: () => StaffAdminWorkspaceClientsClientIdRoute,
    } as any,
  )
const StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdIndexRoute =
  StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRoute,
  } as any)
const StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdEditRoute =
  StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () =>
      StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/client': typeof ClientRouteWithChildren
  '/not-found': typeof NotFoundRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/client/call-now': typeof ClientCallNowRoute
  '/client/dashboard': typeof ClientDashboardRoute
  '/client/profile': typeof ClientProfileRoute
  '/client/login': typeof ClientLoginRoute
  '/forgot-password/sent': typeof ForgotPasswordSentRoute
  '/invite/accept': typeof InviteAcceptRoute
  '/login/mfa': typeof LoginMfaRoute
  '/login/mfa-setup': typeof LoginMfaSetupRoute
  '/reset-password/confirm': typeof ResetPasswordConfirmRoute
  '/sso/$slug': typeof SsoSlugRoute
  '/app/': typeof AppIndexRoute
  '/forgot-password/': typeof ForgotPasswordIndexRoute
  '/invite/': typeof InviteIndexRoute
  '/login/': typeof LoginIndexRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/verify-email/': typeof VerifyEmailIndexRoute
  '/admin/platform': typeof StaffAdminPlatformRouteWithChildren
  '/admin/workspace': typeof StaffAdminWorkspaceRouteWithChildren
  '/app/assessments/$templateId': typeof AppAssessmentsTemplateIdRouteWithChildren
  '/app/case-reports/review-queue': typeof AppCaseReportsReviewQueueRoute
  '/app/chat/$chatId': typeof AppChatChatIdRoute
  '/app/clients/$clientId': typeof AppClientsClientIdRouteWithChildren
  '/app/exercises/$id': typeof AppExercisesIdRoute
  '/app/exercises/review-queue': typeof AppExercisesReviewQueueRoute
  '/app/profile/edit': typeof AppProfileEditRoute
  '/app/red-flags/$id': typeof AppRedFlagsIdRoute
  '/app/sessions/$sessionId': typeof AppSessionsSessionIdRouteWithChildren
  '/app/sessions/book': typeof AppSessionsBookRoute
  '/app/sessions/helpline': typeof AppSessionsHelplineRoute
  '/auth/sso/land': typeof AuthSsoLandRoute
  '/client/book/confirm': typeof ClientBookConfirmRoute
  '/client/book/details': typeof ClientBookDetailsRoute
  '/client/book/practitioner': typeof ClientBookPractitionerRoute
  '/client/book/when': typeof ClientBookWhenRoute
  '/client/chat/$chatId': typeof ClientChatChatIdRoute
  '/client/exercises/$clientExerciseId': typeof ClientExercisesClientExerciseIdRoute
  '/client/library/$resourceId': typeof ClientLibraryResourceIdRoute
  '/client/library/bookmarks': typeof ClientLibraryBookmarksRoute
  '/client/sessions/$sessionId': typeof ClientSessionsSessionIdRoute
  '/client/forgot-password/sent': typeof ClientForgotPasswordSentRoute
  '/client/register/sent': typeof ClientRegisterSentRoute
  '/app/assessments/': typeof AppAssessmentsIndexRoute
  '/app/availability/': typeof AppAvailabilityIndexRoute
  '/app/calendar/': typeof AppCalendarIndexRoute
  '/app/chat/': typeof AppChatIndexRoute
  '/app/clients/': typeof AppClientsIndexRoute
  '/app/exercises/': typeof AppExercisesIndexRoute
  '/app/helpline-demand/': typeof AppHelplineDemandIndexRoute
  '/app/profile/': typeof AppProfileIndexRoute
  '/app/red-flags/': typeof AppRedFlagsIndexRoute
  '/app/sessions/': typeof AppSessionsIndexRoute
  '/app/telephony/': typeof AppTelephonyIndexRoute
  '/client/assessments/': typeof ClientAssessmentsIndexRoute
  '/client/book/': typeof ClientBookIndexRoute
  '/client/chat/': typeof ClientChatIndexRoute
  '/client/exercises/': typeof ClientExercisesIndexRoute
  '/client/library/': typeof ClientLibraryIndexRoute
  '/client/sessions/': typeof ClientSessionsIndexRoute
  '/client/forgot-password/': typeof ClientForgotPasswordIndexRoute
  '/client/onboarding/': typeof ClientOnboardingIndexRoute
  '/client/register/': typeof ClientRegisterIndexRoute
  '/org/portal/compliance': typeof OrgOrgPortalComplianceRoute
  '/org/portal/dashboard': typeof OrgOrgPortalDashboardRoute
  '/org/portal/statistics': typeof OrgOrgPortalStatisticsRoute
  '/app/assessments/$templateId/assign': typeof AppAssessmentsTemplateIdAssignRoute
  '/app/assessments/$templateId/bulk-assign': typeof AppAssessmentsTemplateIdBulkAssignRoute
  '/app/assessments/assignments/$assignmentId': typeof AppAssessmentsAssignmentsAssignmentIdRoute
  '/app/engagement/resources/$id': typeof AppEngagementResourcesIdRoute
  '/app/sessions/$sessionId/note': typeof AppSessionsSessionIdNoteRoute
  '/client/assessments/$assessmentId/$assignmentId': typeof ClientAssessmentsAssessmentIdAssignmentIdRouteWithChildren
  '/client/book/success/$sessionId': typeof ClientBookSuccessSessionIdRoute
  '/org/portal/': typeof OrgOrgPortalIndexRoute
  '/admin/platform/': typeof StaffAdminPlatformIndexRoute
  '/admin/workspace/': typeof StaffAdminWorkspaceIndexRoute
  '/app/assessments/$templateId/': typeof AppAssessmentsTemplateIdIndexRoute
  '/app/assessments/assignments/': typeof AppAssessmentsAssignmentsIndexRoute
  '/app/clients/$clientId/': typeof AppClientsClientIdIndexRoute
  '/app/engagement/resources/': typeof AppEngagementResourcesIndexRoute
  '/client/sessions/$sessionId/call': typeof ClientFullscreenClientSessionsSessionIdCallRoute
  '/app/sessions/$sessionId/call': typeof StaffFullscreenAppSessionsSessionIdCallRoute
  '/admin/platform/assessments/$templateId': typeof StaffAdminPlatformAssessmentsTemplateIdRouteWithChildren
  '/admin/platform/business-associates/$baId': typeof StaffAdminPlatformBusinessAssociatesBaIdRouteWithChildren
  '/admin/platform/business-associates/new': typeof StaffAdminPlatformBusinessAssociatesNewRoute
  '/admin/platform/clients/$clientId': typeof StaffAdminPlatformClientsClientIdRoute
  '/admin/platform/organizations/$orgId': typeof StaffAdminPlatformOrganizationsOrgIdRoute
  '/admin/platform/practitioners/$practitionerId': typeof StaffAdminPlatformPractitionersPractitionerIdRoute
  '/admin/platform/sessions/$sessionId': typeof StaffAdminPlatformSessionsSessionIdRoute
  '/admin/platform/telephony/agents': typeof StaffAdminPlatformTelephonyAgentsRoute
  '/admin/platform/telephony/did-mappings': typeof StaffAdminPlatformTelephonyDidMappingsRoute
  '/admin/platform/users/$userId': typeof StaffAdminPlatformUsersUserIdRoute
  '/admin/workspace/assessments/$templateId': typeof StaffAdminWorkspaceAssessmentsTemplateIdRouteWithChildren
  '/admin/workspace/assessments/new': typeof StaffAdminWorkspaceAssessmentsNewRoute
  '/admin/workspace/clients/$clientId': typeof StaffAdminWorkspaceClientsClientIdRouteWithChildren
  '/admin/workspace/exercises/$id': typeof StaffAdminWorkspaceExercisesIdRouteWithChildren
  '/admin/workspace/exercises/new': typeof StaffAdminWorkspaceExercisesNewRoute
  '/admin/workspace/organizations/$orgId': typeof StaffAdminWorkspaceOrganizationsOrgIdRouteWithChildren
  '/admin/workspace/organizations/new': typeof StaffAdminWorkspaceOrganizationsNewRoute
  '/admin/workspace/practitioners/$practitionerId': typeof StaffAdminWorkspacePractitionersPractitionerIdRouteWithChildren
  '/admin/workspace/red-flags/$id': typeof StaffAdminWorkspaceRedFlagsIdRoute
  '/admin/workspace/sessions/$sessionId': typeof StaffAdminWorkspaceSessionsSessionIdRouteWithChildren
  '/admin/workspace/sessions/book': typeof StaffAdminWorkspaceSessionsBookRoute
  '/admin/workspace/telephony/agents': typeof StaffAdminWorkspaceTelephonyAgentsRoute
  '/admin/workspace/telephony/did-mappings': typeof StaffAdminWorkspaceTelephonyDidMappingsRoute
  '/admin/workspace/users/$userId': typeof StaffAdminWorkspaceUsersUserIdRoute
  '/admin/workspace/users/invite': typeof StaffAdminWorkspaceUsersInviteRoute
  '/app/clients/$clientId/exercises/$clientExerciseId': typeof AppClientsClientIdExercisesClientExerciseIdRoute
  '/app/sessions/$sessionId/case-reports/$reportId': typeof AppSessionsSessionIdCaseReportsReportIdRoute
  '/app/sessions/$sessionId/case-reports/new': typeof AppSessionsSessionIdCaseReportsNewRoute
  '/client/assessments/$assessmentId/$assignmentId/result': typeof ClientAssessmentsAssessmentIdAssignmentIdResultRoute
  '/admin/platform/assessments/': typeof StaffAdminPlatformAssessmentsIndexRoute
  '/admin/platform/business-associates/': typeof StaffAdminPlatformBusinessAssociatesIndexRoute
  '/admin/platform/clients/': typeof StaffAdminPlatformClientsIndexRoute
  '/admin/platform/organizations/': typeof StaffAdminPlatformOrganizationsIndexRoute
  '/admin/platform/practitioners/': typeof StaffAdminPlatformPractitionersIndexRoute
  '/admin/platform/red-flags/': typeof StaffAdminPlatformRedFlagsIndexRoute
  '/admin/platform/sessions/': typeof StaffAdminPlatformSessionsIndexRoute
  '/admin/platform/users/': typeof StaffAdminPlatformUsersIndexRoute
  '/admin/workspace/assessments/': typeof StaffAdminWorkspaceAssessmentsIndexRoute
  '/admin/workspace/chats/': typeof StaffAdminWorkspaceChatsIndexRoute
  '/admin/workspace/clients/': typeof StaffAdminWorkspaceClientsIndexRoute
  '/admin/workspace/exercises/': typeof StaffAdminWorkspaceExercisesIndexRoute
  '/admin/workspace/helpline-demand/': typeof StaffAdminWorkspaceHelplineDemandIndexRoute
  '/admin/workspace/organizations/': typeof StaffAdminWorkspaceOrganizationsIndexRoute
  '/admin/workspace/practitioners/': typeof StaffAdminWorkspacePractitionersIndexRoute
  '/admin/workspace/red-flags/': typeof StaffAdminWorkspaceRedFlagsIndexRoute
  '/admin/workspace/sessions/': typeof StaffAdminWorkspaceSessionsIndexRoute
  '/admin/workspace/telephony/': typeof StaffAdminWorkspaceTelephonyIndexRoute
  '/admin/workspace/users/': typeof StaffAdminWorkspaceUsersIndexRoute
  '/client/assessments/$assessmentId/$assignmentId/': typeof ClientAssessmentsAssessmentIdAssignmentIdIndexRoute
  '/admin/workspace/sessions/$sessionId/call': typeof StaffFullscreenAdminWorkspaceSessionsSessionIdCallRoute
  '/admin/platform/assessments/assignments/$assignmentId': typeof StaffAdminPlatformAssessmentsAssignmentsAssignmentIdRoute
  '/admin/platform/business-associates/$baId/edit': typeof StaffAdminPlatformBusinessAssociatesBaIdEditRoute
  '/admin/workspace/assessments/$templateId/assign': typeof StaffAdminWorkspaceAssessmentsTemplateIdAssignRoute
  '/admin/workspace/assessments/$templateId/bulk-assign': typeof StaffAdminWorkspaceAssessmentsTemplateIdBulkAssignRoute
  '/admin/workspace/assessments/assignments/$assignmentId': typeof StaffAdminWorkspaceAssessmentsAssignmentsAssignmentIdRoute
  '/admin/workspace/clients/$clientId/edit': typeof StaffAdminWorkspaceClientsClientIdEditRoute
  '/admin/workspace/engagement/resources/$id': typeof StaffAdminWorkspaceEngagementResourcesIdRouteWithChildren
  '/admin/workspace/engagement/resources/new': typeof StaffAdminWorkspaceEngagementResourcesNewRoute
  '/admin/workspace/exercises/$id/edit': typeof StaffAdminWorkspaceExercisesIdEditRoute
  '/admin/workspace/organizations/$orgId/edit': typeof StaffAdminWorkspaceOrganizationsOrgIdEditRoute
  '/admin/workspace/practitioners/$practitionerId/edit': typeof StaffAdminWorkspacePractitionersPractitionerIdEditRoute
  '/admin/workspace/sessions/$sessionId/note': typeof StaffAdminWorkspaceSessionsSessionIdNoteRoute
  '/admin/platform/assessments/$templateId/': typeof StaffAdminPlatformAssessmentsTemplateIdIndexRoute
  '/admin/platform/assessments/assignments/': typeof StaffAdminPlatformAssessmentsAssignmentsIndexRoute
  '/admin/platform/business-associates/$baId/': typeof StaffAdminPlatformBusinessAssociatesBaIdIndexRoute
  '/admin/workspace/assessments/$templateId/': typeof StaffAdminWorkspaceAssessmentsTemplateIdIndexRoute
  '/admin/workspace/assessments/assignments/': typeof StaffAdminWorkspaceAssessmentsAssignmentsIndexRoute
  '/admin/workspace/clients/$clientId/': typeof StaffAdminWorkspaceClientsClientIdIndexRoute
  '/admin/workspace/engagement/resources/': typeof StaffAdminWorkspaceEngagementResourcesIndexRoute
  '/admin/workspace/exercises/$id/': typeof StaffAdminWorkspaceExercisesIdIndexRoute
  '/admin/workspace/organizations/$orgId/': typeof StaffAdminWorkspaceOrganizationsOrgIdIndexRoute
  '/admin/workspace/practitioners/$practitionerId/': typeof StaffAdminWorkspacePractitionersPractitionerIdIndexRoute
  '/admin/workspace/clients/$clientId/exercises/$clientExerciseId': typeof StaffAdminWorkspaceClientsClientIdExercisesClientExerciseIdRoute
  '/admin/workspace/engagement/resources/$id/edit': typeof StaffAdminWorkspaceEngagementResourcesIdEditRoute
  '/admin/workspace/organizations/$orgId/locations/$locId': typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRouteWithChildren
  '/admin/workspace/organizations/$orgId/locations/new': typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsNewRoute
  '/admin/workspace/sessions/$sessionId/case-reports/$reportId': typeof StaffAdminWorkspaceSessionsSessionIdCaseReportsReportIdRoute
  '/admin/workspace/sessions/$sessionId/case-reports/new': typeof StaffAdminWorkspaceSessionsSessionIdCaseReportsNewRoute
  '/admin/workspace/engagement/resources/$id/': typeof StaffAdminWorkspaceEngagementResourcesIdIndexRoute
  '/admin/workspace/organizations/$orgId/locations/$locId/edit': typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdEditRoute
  '/admin/workspace/organizations/$orgId/locations/$locId/': typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/client': typeof ClientRouteWithChildren
  '/not-found': typeof NotFoundRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/client/call-now': typeof ClientCallNowRoute
  '/client/dashboard': typeof ClientDashboardRoute
  '/client/profile': typeof ClientProfileRoute
  '/client/login': typeof ClientLoginRoute
  '/forgot-password/sent': typeof ForgotPasswordSentRoute
  '/invite/accept': typeof InviteAcceptRoute
  '/login/mfa': typeof LoginMfaRoute
  '/login/mfa-setup': typeof LoginMfaSetupRoute
  '/reset-password/confirm': typeof ResetPasswordConfirmRoute
  '/sso/$slug': typeof SsoSlugRoute
  '/app': typeof AppIndexRoute
  '/forgot-password': typeof ForgotPasswordIndexRoute
  '/invite': typeof InviteIndexRoute
  '/login': typeof LoginIndexRoute
  '/reset-password': typeof ResetPasswordIndexRoute
  '/verify-email': typeof VerifyEmailIndexRoute
  '/app/case-reports/review-queue': typeof AppCaseReportsReviewQueueRoute
  '/app/chat/$chatId': typeof AppChatChatIdRoute
  '/app/exercises/$id': typeof AppExercisesIdRoute
  '/app/exercises/review-queue': typeof AppExercisesReviewQueueRoute
  '/app/profile/edit': typeof AppProfileEditRoute
  '/app/red-flags/$id': typeof AppRedFlagsIdRoute
  '/app/sessions/$sessionId': typeof AppSessionsSessionIdRouteWithChildren
  '/app/sessions/book': typeof AppSessionsBookRoute
  '/app/sessions/helpline': typeof AppSessionsHelplineRoute
  '/auth/sso/land': typeof AuthSsoLandRoute
  '/client/book/confirm': typeof ClientBookConfirmRoute
  '/client/book/details': typeof ClientBookDetailsRoute
  '/client/book/practitioner': typeof ClientBookPractitionerRoute
  '/client/book/when': typeof ClientBookWhenRoute
  '/client/chat/$chatId': typeof ClientChatChatIdRoute
  '/client/exercises/$clientExerciseId': typeof ClientExercisesClientExerciseIdRoute
  '/client/library/$resourceId': typeof ClientLibraryResourceIdRoute
  '/client/library/bookmarks': typeof ClientLibraryBookmarksRoute
  '/client/sessions/$sessionId': typeof ClientSessionsSessionIdRoute
  '/client/forgot-password/sent': typeof ClientForgotPasswordSentRoute
  '/client/register/sent': typeof ClientRegisterSentRoute
  '/app/assessments': typeof AppAssessmentsIndexRoute
  '/app/availability': typeof AppAvailabilityIndexRoute
  '/app/calendar': typeof AppCalendarIndexRoute
  '/app/chat': typeof AppChatIndexRoute
  '/app/clients': typeof AppClientsIndexRoute
  '/app/exercises': typeof AppExercisesIndexRoute
  '/app/helpline-demand': typeof AppHelplineDemandIndexRoute
  '/app/profile': typeof AppProfileIndexRoute
  '/app/red-flags': typeof AppRedFlagsIndexRoute
  '/app/sessions': typeof AppSessionsIndexRoute
  '/app/telephony': typeof AppTelephonyIndexRoute
  '/client/assessments': typeof ClientAssessmentsIndexRoute
  '/client/book': typeof ClientBookIndexRoute
  '/client/chat': typeof ClientChatIndexRoute
  '/client/exercises': typeof ClientExercisesIndexRoute
  '/client/library': typeof ClientLibraryIndexRoute
  '/client/sessions': typeof ClientSessionsIndexRoute
  '/client/forgot-password': typeof ClientForgotPasswordIndexRoute
  '/client/onboarding': typeof ClientOnboardingIndexRoute
  '/client/register': typeof ClientRegisterIndexRoute
  '/org/portal/compliance': typeof OrgOrgPortalComplianceRoute
  '/org/portal/dashboard': typeof OrgOrgPortalDashboardRoute
  '/org/portal/statistics': typeof OrgOrgPortalStatisticsRoute
  '/app/assessments/$templateId/assign': typeof AppAssessmentsTemplateIdAssignRoute
  '/app/assessments/$templateId/bulk-assign': typeof AppAssessmentsTemplateIdBulkAssignRoute
  '/app/assessments/assignments/$assignmentId': typeof AppAssessmentsAssignmentsAssignmentIdRoute
  '/app/engagement/resources/$id': typeof AppEngagementResourcesIdRoute
  '/app/sessions/$sessionId/note': typeof AppSessionsSessionIdNoteRoute
  '/client/book/success/$sessionId': typeof ClientBookSuccessSessionIdRoute
  '/org/portal': typeof OrgOrgPortalIndexRoute
  '/admin/platform': typeof StaffAdminPlatformIndexRoute
  '/admin/workspace': typeof StaffAdminWorkspaceIndexRoute
  '/app/assessments/$templateId': typeof AppAssessmentsTemplateIdIndexRoute
  '/app/assessments/assignments': typeof AppAssessmentsAssignmentsIndexRoute
  '/app/clients/$clientId': typeof AppClientsClientIdIndexRoute
  '/app/engagement/resources': typeof AppEngagementResourcesIndexRoute
  '/client/sessions/$sessionId/call': typeof ClientFullscreenClientSessionsSessionIdCallRoute
  '/app/sessions/$sessionId/call': typeof StaffFullscreenAppSessionsSessionIdCallRoute
  '/admin/platform/business-associates/new': typeof StaffAdminPlatformBusinessAssociatesNewRoute
  '/admin/platform/clients/$clientId': typeof StaffAdminPlatformClientsClientIdRoute
  '/admin/platform/organizations/$orgId': typeof StaffAdminPlatformOrganizationsOrgIdRoute
  '/admin/platform/practitioners/$practitionerId': typeof StaffAdminPlatformPractitionersPractitionerIdRoute
  '/admin/platform/sessions/$sessionId': typeof StaffAdminPlatformSessionsSessionIdRoute
  '/admin/platform/telephony/agents': typeof StaffAdminPlatformTelephonyAgentsRoute
  '/admin/platform/telephony/did-mappings': typeof StaffAdminPlatformTelephonyDidMappingsRoute
  '/admin/platform/users/$userId': typeof StaffAdminPlatformUsersUserIdRoute
  '/admin/workspace/assessments/new': typeof StaffAdminWorkspaceAssessmentsNewRoute
  '/admin/workspace/exercises/new': typeof StaffAdminWorkspaceExercisesNewRoute
  '/admin/workspace/organizations/new': typeof StaffAdminWorkspaceOrganizationsNewRoute
  '/admin/workspace/red-flags/$id': typeof StaffAdminWorkspaceRedFlagsIdRoute
  '/admin/workspace/sessions/$sessionId': typeof StaffAdminWorkspaceSessionsSessionIdRouteWithChildren
  '/admin/workspace/sessions/book': typeof StaffAdminWorkspaceSessionsBookRoute
  '/admin/workspace/telephony/agents': typeof StaffAdminWorkspaceTelephonyAgentsRoute
  '/admin/workspace/telephony/did-mappings': typeof StaffAdminWorkspaceTelephonyDidMappingsRoute
  '/admin/workspace/users/$userId': typeof StaffAdminWorkspaceUsersUserIdRoute
  '/admin/workspace/users/invite': typeof StaffAdminWorkspaceUsersInviteRoute
  '/app/clients/$clientId/exercises/$clientExerciseId': typeof AppClientsClientIdExercisesClientExerciseIdRoute
  '/app/sessions/$sessionId/case-reports/$reportId': typeof AppSessionsSessionIdCaseReportsReportIdRoute
  '/app/sessions/$sessionId/case-reports/new': typeof AppSessionsSessionIdCaseReportsNewRoute
  '/client/assessments/$assessmentId/$assignmentId/result': typeof ClientAssessmentsAssessmentIdAssignmentIdResultRoute
  '/admin/platform/assessments': typeof StaffAdminPlatformAssessmentsIndexRoute
  '/admin/platform/business-associates': typeof StaffAdminPlatformBusinessAssociatesIndexRoute
  '/admin/platform/clients': typeof StaffAdminPlatformClientsIndexRoute
  '/admin/platform/organizations': typeof StaffAdminPlatformOrganizationsIndexRoute
  '/admin/platform/practitioners': typeof StaffAdminPlatformPractitionersIndexRoute
  '/admin/platform/red-flags': typeof StaffAdminPlatformRedFlagsIndexRoute
  '/admin/platform/sessions': typeof StaffAdminPlatformSessionsIndexRoute
  '/admin/platform/users': typeof StaffAdminPlatformUsersIndexRoute
  '/admin/workspace/assessments': typeof StaffAdminWorkspaceAssessmentsIndexRoute
  '/admin/workspace/chats': typeof StaffAdminWorkspaceChatsIndexRoute
  '/admin/workspace/clients': typeof StaffAdminWorkspaceClientsIndexRoute
  '/admin/workspace/exercises': typeof StaffAdminWorkspaceExercisesIndexRoute
  '/admin/workspace/helpline-demand': typeof StaffAdminWorkspaceHelplineDemandIndexRoute
  '/admin/workspace/organizations': typeof StaffAdminWorkspaceOrganizationsIndexRoute
  '/admin/workspace/practitioners': typeof StaffAdminWorkspacePractitionersIndexRoute
  '/admin/workspace/red-flags': typeof StaffAdminWorkspaceRedFlagsIndexRoute
  '/admin/workspace/sessions': typeof StaffAdminWorkspaceSessionsIndexRoute
  '/admin/workspace/telephony': typeof StaffAdminWorkspaceTelephonyIndexRoute
  '/admin/workspace/users': typeof StaffAdminWorkspaceUsersIndexRoute
  '/client/assessments/$assessmentId/$assignmentId': typeof ClientAssessmentsAssessmentIdAssignmentIdIndexRoute
  '/admin/workspace/sessions/$sessionId/call': typeof StaffFullscreenAdminWorkspaceSessionsSessionIdCallRoute
  '/admin/platform/assessments/assignments/$assignmentId': typeof StaffAdminPlatformAssessmentsAssignmentsAssignmentIdRoute
  '/admin/platform/business-associates/$baId/edit': typeof StaffAdminPlatformBusinessAssociatesBaIdEditRoute
  '/admin/workspace/assessments/$templateId/assign': typeof StaffAdminWorkspaceAssessmentsTemplateIdAssignRoute
  '/admin/workspace/assessments/$templateId/bulk-assign': typeof StaffAdminWorkspaceAssessmentsTemplateIdBulkAssignRoute
  '/admin/workspace/assessments/assignments/$assignmentId': typeof StaffAdminWorkspaceAssessmentsAssignmentsAssignmentIdRoute
  '/admin/workspace/clients/$clientId/edit': typeof StaffAdminWorkspaceClientsClientIdEditRoute
  '/admin/workspace/engagement/resources/new': typeof StaffAdminWorkspaceEngagementResourcesNewRoute
  '/admin/workspace/exercises/$id/edit': typeof StaffAdminWorkspaceExercisesIdEditRoute
  '/admin/workspace/organizations/$orgId/edit': typeof StaffAdminWorkspaceOrganizationsOrgIdEditRoute
  '/admin/workspace/practitioners/$practitionerId/edit': typeof StaffAdminWorkspacePractitionersPractitionerIdEditRoute
  '/admin/workspace/sessions/$sessionId/note': typeof StaffAdminWorkspaceSessionsSessionIdNoteRoute
  '/admin/platform/assessments/$templateId': typeof StaffAdminPlatformAssessmentsTemplateIdIndexRoute
  '/admin/platform/assessments/assignments': typeof StaffAdminPlatformAssessmentsAssignmentsIndexRoute
  '/admin/platform/business-associates/$baId': typeof StaffAdminPlatformBusinessAssociatesBaIdIndexRoute
  '/admin/workspace/assessments/$templateId': typeof StaffAdminWorkspaceAssessmentsTemplateIdIndexRoute
  '/admin/workspace/assessments/assignments': typeof StaffAdminWorkspaceAssessmentsAssignmentsIndexRoute
  '/admin/workspace/clients/$clientId': typeof StaffAdminWorkspaceClientsClientIdIndexRoute
  '/admin/workspace/engagement/resources': typeof StaffAdminWorkspaceEngagementResourcesIndexRoute
  '/admin/workspace/exercises/$id': typeof StaffAdminWorkspaceExercisesIdIndexRoute
  '/admin/workspace/organizations/$orgId': typeof StaffAdminWorkspaceOrganizationsOrgIdIndexRoute
  '/admin/workspace/practitioners/$practitionerId': typeof StaffAdminWorkspacePractitionersPractitionerIdIndexRoute
  '/admin/workspace/clients/$clientId/exercises/$clientExerciseId': typeof StaffAdminWorkspaceClientsClientIdExercisesClientExerciseIdRoute
  '/admin/workspace/engagement/resources/$id/edit': typeof StaffAdminWorkspaceEngagementResourcesIdEditRoute
  '/admin/workspace/organizations/$orgId/locations/new': typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsNewRoute
  '/admin/workspace/sessions/$sessionId/case-reports/$reportId': typeof StaffAdminWorkspaceSessionsSessionIdCaseReportsReportIdRoute
  '/admin/workspace/sessions/$sessionId/case-reports/new': typeof StaffAdminWorkspaceSessionsSessionIdCaseReportsNewRoute
  '/admin/workspace/engagement/resources/$id': typeof StaffAdminWorkspaceEngagementResourcesIdIndexRoute
  '/admin/workspace/organizations/$orgId/locations/$locId/edit': typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdEditRoute
  '/admin/workspace/organizations/$orgId/locations/$locId': typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_client-fullscreen': typeof ClientFullscreenRouteWithChildren
  '/_org': typeof OrgRouteWithChildren
  '/_staff-fullscreen': typeof StaffFullscreenRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/client': typeof ClientRouteWithChildren
  '/not-found': typeof NotFoundRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/client/call-now': typeof ClientCallNowRoute
  '/client/dashboard': typeof ClientDashboardRoute
  '/client/profile': typeof ClientProfileRoute
  '/client_/login': typeof ClientLoginRoute
  '/forgot-password/sent': typeof ForgotPasswordSentRoute
  '/invite/accept': typeof InviteAcceptRoute
  '/login/mfa': typeof LoginMfaRoute
  '/login/mfa-setup': typeof LoginMfaSetupRoute
  '/reset-password/confirm': typeof ResetPasswordConfirmRoute
  '/sso/$slug': typeof SsoSlugRoute
  '/app/': typeof AppIndexRoute
  '/forgot-password/': typeof ForgotPasswordIndexRoute
  '/invite/': typeof InviteIndexRoute
  '/login/': typeof LoginIndexRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/verify-email/': typeof VerifyEmailIndexRoute
  '/_staff/admin/platform': typeof StaffAdminPlatformRouteWithChildren
  '/_staff/admin/workspace': typeof StaffAdminWorkspaceRouteWithChildren
  '/app/assessments/$templateId': typeof AppAssessmentsTemplateIdRouteWithChildren
  '/app/case-reports/review-queue': typeof AppCaseReportsReviewQueueRoute
  '/app/chat/$chatId': typeof AppChatChatIdRoute
  '/app/clients/$clientId': typeof AppClientsClientIdRouteWithChildren
  '/app/exercises/$id': typeof AppExercisesIdRoute
  '/app/exercises/review-queue': typeof AppExercisesReviewQueueRoute
  '/app/profile/edit': typeof AppProfileEditRoute
  '/app/red-flags/$id': typeof AppRedFlagsIdRoute
  '/app/sessions/$sessionId': typeof AppSessionsSessionIdRouteWithChildren
  '/app/sessions/book': typeof AppSessionsBookRoute
  '/app/sessions/helpline': typeof AppSessionsHelplineRoute
  '/auth/sso/land': typeof AuthSsoLandRoute
  '/client/book/confirm': typeof ClientBookConfirmRoute
  '/client/book/details': typeof ClientBookDetailsRoute
  '/client/book/practitioner': typeof ClientBookPractitionerRoute
  '/client/book/when': typeof ClientBookWhenRoute
  '/client/chat/$chatId': typeof ClientChatChatIdRoute
  '/client/exercises/$clientExerciseId': typeof ClientExercisesClientExerciseIdRoute
  '/client/library/$resourceId': typeof ClientLibraryResourceIdRoute
  '/client/library/bookmarks': typeof ClientLibraryBookmarksRoute
  '/client/sessions/$sessionId': typeof ClientSessionsSessionIdRoute
  '/client_/forgot-password/sent': typeof ClientForgotPasswordSentRoute
  '/client_/register/sent': typeof ClientRegisterSentRoute
  '/app/assessments/': typeof AppAssessmentsIndexRoute
  '/app/availability/': typeof AppAvailabilityIndexRoute
  '/app/calendar/': typeof AppCalendarIndexRoute
  '/app/chat/': typeof AppChatIndexRoute
  '/app/clients/': typeof AppClientsIndexRoute
  '/app/exercises/': typeof AppExercisesIndexRoute
  '/app/helpline-demand/': typeof AppHelplineDemandIndexRoute
  '/app/profile/': typeof AppProfileIndexRoute
  '/app/red-flags/': typeof AppRedFlagsIndexRoute
  '/app/sessions/': typeof AppSessionsIndexRoute
  '/app/telephony/': typeof AppTelephonyIndexRoute
  '/client/assessments/': typeof ClientAssessmentsIndexRoute
  '/client/book/': typeof ClientBookIndexRoute
  '/client/chat/': typeof ClientChatIndexRoute
  '/client/exercises/': typeof ClientExercisesIndexRoute
  '/client/library/': typeof ClientLibraryIndexRoute
  '/client/sessions/': typeof ClientSessionsIndexRoute
  '/client_/forgot-password/': typeof ClientForgotPasswordIndexRoute
  '/client_/onboarding/': typeof ClientOnboardingIndexRoute
  '/client_/register/': typeof ClientRegisterIndexRoute
  '/_org/org/portal/compliance': typeof OrgOrgPortalComplianceRoute
  '/_org/org/portal/dashboard': typeof OrgOrgPortalDashboardRoute
  '/_org/org/portal/statistics': typeof OrgOrgPortalStatisticsRoute
  '/app/assessments/$templateId/assign': typeof AppAssessmentsTemplateIdAssignRoute
  '/app/assessments/$templateId/bulk-assign': typeof AppAssessmentsTemplateIdBulkAssignRoute
  '/app/assessments/assignments/$assignmentId': typeof AppAssessmentsAssignmentsAssignmentIdRoute
  '/app/engagement/resources/$id': typeof AppEngagementResourcesIdRoute
  '/app/sessions/$sessionId/note': typeof AppSessionsSessionIdNoteRoute
  '/client/assessments/$assessmentId/$assignmentId': typeof ClientAssessmentsAssessmentIdAssignmentIdRouteWithChildren
  '/client/book/success/$sessionId': typeof ClientBookSuccessSessionIdRoute
  '/_org/org/portal/': typeof OrgOrgPortalIndexRoute
  '/_staff/admin/platform/': typeof StaffAdminPlatformIndexRoute
  '/_staff/admin/workspace/': typeof StaffAdminWorkspaceIndexRoute
  '/app/assessments/$templateId/': typeof AppAssessmentsTemplateIdIndexRoute
  '/app/assessments/assignments/': typeof AppAssessmentsAssignmentsIndexRoute
  '/app/clients/$clientId/': typeof AppClientsClientIdIndexRoute
  '/app/engagement/resources/': typeof AppEngagementResourcesIndexRoute
  '/_client-fullscreen/client/sessions/$sessionId/call': typeof ClientFullscreenClientSessionsSessionIdCallRoute
  '/_staff-fullscreen/app/sessions/$sessionId/call': typeof StaffFullscreenAppSessionsSessionIdCallRoute
  '/_staff/admin/platform/assessments/$templateId': typeof StaffAdminPlatformAssessmentsTemplateIdRouteWithChildren
  '/_staff/admin/platform/business-associates/$baId': typeof StaffAdminPlatformBusinessAssociatesBaIdRouteWithChildren
  '/_staff/admin/platform/business-associates/new': typeof StaffAdminPlatformBusinessAssociatesNewRoute
  '/_staff/admin/platform/clients/$clientId': typeof StaffAdminPlatformClientsClientIdRoute
  '/_staff/admin/platform/organizations/$orgId': typeof StaffAdminPlatformOrganizationsOrgIdRoute
  '/_staff/admin/platform/practitioners/$practitionerId': typeof StaffAdminPlatformPractitionersPractitionerIdRoute
  '/_staff/admin/platform/sessions/$sessionId': typeof StaffAdminPlatformSessionsSessionIdRoute
  '/_staff/admin/platform/telephony/agents': typeof StaffAdminPlatformTelephonyAgentsRoute
  '/_staff/admin/platform/telephony/did-mappings': typeof StaffAdminPlatformTelephonyDidMappingsRoute
  '/_staff/admin/platform/users/$userId': typeof StaffAdminPlatformUsersUserIdRoute
  '/_staff/admin/workspace/assessments/$templateId': typeof StaffAdminWorkspaceAssessmentsTemplateIdRouteWithChildren
  '/_staff/admin/workspace/assessments/new': typeof StaffAdminWorkspaceAssessmentsNewRoute
  '/_staff/admin/workspace/clients/$clientId': typeof StaffAdminWorkspaceClientsClientIdRouteWithChildren
  '/_staff/admin/workspace/exercises/$id': typeof StaffAdminWorkspaceExercisesIdRouteWithChildren
  '/_staff/admin/workspace/exercises/new': typeof StaffAdminWorkspaceExercisesNewRoute
  '/_staff/admin/workspace/organizations/$orgId': typeof StaffAdminWorkspaceOrganizationsOrgIdRouteWithChildren
  '/_staff/admin/workspace/organizations/new': typeof StaffAdminWorkspaceOrganizationsNewRoute
  '/_staff/admin/workspace/practitioners/$practitionerId': typeof StaffAdminWorkspacePractitionersPractitionerIdRouteWithChildren
  '/_staff/admin/workspace/red-flags/$id': typeof StaffAdminWorkspaceRedFlagsIdRoute
  '/_staff/admin/workspace/sessions/$sessionId': typeof StaffAdminWorkspaceSessionsSessionIdRouteWithChildren
  '/_staff/admin/workspace/sessions/book': typeof StaffAdminWorkspaceSessionsBookRoute
  '/_staff/admin/workspace/telephony/agents': typeof StaffAdminWorkspaceTelephonyAgentsRoute
  '/_staff/admin/workspace/telephony/did-mappings': typeof StaffAdminWorkspaceTelephonyDidMappingsRoute
  '/_staff/admin/workspace/users/$userId': typeof StaffAdminWorkspaceUsersUserIdRoute
  '/_staff/admin/workspace/users/invite': typeof StaffAdminWorkspaceUsersInviteRoute
  '/app/clients/$clientId/exercises/$clientExerciseId': typeof AppClientsClientIdExercisesClientExerciseIdRoute
  '/app/sessions/$sessionId/case-reports/$reportId': typeof AppSessionsSessionIdCaseReportsReportIdRoute
  '/app/sessions/$sessionId/case-reports/new': typeof AppSessionsSessionIdCaseReportsNewRoute
  '/client/assessments/$assessmentId/$assignmentId/result': typeof ClientAssessmentsAssessmentIdAssignmentIdResultRoute
  '/_staff/admin/platform/assessments/': typeof StaffAdminPlatformAssessmentsIndexRoute
  '/_staff/admin/platform/business-associates/': typeof StaffAdminPlatformBusinessAssociatesIndexRoute
  '/_staff/admin/platform/clients/': typeof StaffAdminPlatformClientsIndexRoute
  '/_staff/admin/platform/organizations/': typeof StaffAdminPlatformOrganizationsIndexRoute
  '/_staff/admin/platform/practitioners/': typeof StaffAdminPlatformPractitionersIndexRoute
  '/_staff/admin/platform/red-flags/': typeof StaffAdminPlatformRedFlagsIndexRoute
  '/_staff/admin/platform/sessions/': typeof StaffAdminPlatformSessionsIndexRoute
  '/_staff/admin/platform/users/': typeof StaffAdminPlatformUsersIndexRoute
  '/_staff/admin/workspace/assessments/': typeof StaffAdminWorkspaceAssessmentsIndexRoute
  '/_staff/admin/workspace/chats/': typeof StaffAdminWorkspaceChatsIndexRoute
  '/_staff/admin/workspace/clients/': typeof StaffAdminWorkspaceClientsIndexRoute
  '/_staff/admin/workspace/exercises/': typeof StaffAdminWorkspaceExercisesIndexRoute
  '/_staff/admin/workspace/helpline-demand/': typeof StaffAdminWorkspaceHelplineDemandIndexRoute
  '/_staff/admin/workspace/organizations/': typeof StaffAdminWorkspaceOrganizationsIndexRoute
  '/_staff/admin/workspace/practitioners/': typeof StaffAdminWorkspacePractitionersIndexRoute
  '/_staff/admin/workspace/red-flags/': typeof StaffAdminWorkspaceRedFlagsIndexRoute
  '/_staff/admin/workspace/sessions/': typeof StaffAdminWorkspaceSessionsIndexRoute
  '/_staff/admin/workspace/telephony/': typeof StaffAdminWorkspaceTelephonyIndexRoute
  '/_staff/admin/workspace/users/': typeof StaffAdminWorkspaceUsersIndexRoute
  '/client/assessments/$assessmentId/$assignmentId/': typeof ClientAssessmentsAssessmentIdAssignmentIdIndexRoute
  '/_staff-fullscreen/admin/workspace/sessions/$sessionId/call': typeof StaffFullscreenAdminWorkspaceSessionsSessionIdCallRoute
  '/_staff/admin/platform/assessments/assignments/$assignmentId': typeof StaffAdminPlatformAssessmentsAssignmentsAssignmentIdRoute
  '/_staff/admin/platform/business-associates/$baId/edit': typeof StaffAdminPlatformBusinessAssociatesBaIdEditRoute
  '/_staff/admin/workspace/assessments/$templateId/assign': typeof StaffAdminWorkspaceAssessmentsTemplateIdAssignRoute
  '/_staff/admin/workspace/assessments/$templateId/bulk-assign': typeof StaffAdminWorkspaceAssessmentsTemplateIdBulkAssignRoute
  '/_staff/admin/workspace/assessments/assignments/$assignmentId': typeof StaffAdminWorkspaceAssessmentsAssignmentsAssignmentIdRoute
  '/_staff/admin/workspace/clients/$clientId/edit': typeof StaffAdminWorkspaceClientsClientIdEditRoute
  '/_staff/admin/workspace/engagement/resources/$id': typeof StaffAdminWorkspaceEngagementResourcesIdRouteWithChildren
  '/_staff/admin/workspace/engagement/resources/new': typeof StaffAdminWorkspaceEngagementResourcesNewRoute
  '/_staff/admin/workspace/exercises/$id/edit': typeof StaffAdminWorkspaceExercisesIdEditRoute
  '/_staff/admin/workspace/organizations/$orgId/edit': typeof StaffAdminWorkspaceOrganizationsOrgIdEditRoute
  '/_staff/admin/workspace/practitioners/$practitionerId/edit': typeof StaffAdminWorkspacePractitionersPractitionerIdEditRoute
  '/_staff/admin/workspace/sessions/$sessionId/note': typeof StaffAdminWorkspaceSessionsSessionIdNoteRoute
  '/_staff/admin/platform/assessments/$templateId/': typeof StaffAdminPlatformAssessmentsTemplateIdIndexRoute
  '/_staff/admin/platform/assessments/assignments/': typeof StaffAdminPlatformAssessmentsAssignmentsIndexRoute
  '/_staff/admin/platform/business-associates/$baId/': typeof StaffAdminPlatformBusinessAssociatesBaIdIndexRoute
  '/_staff/admin/workspace/assessments/$templateId/': typeof StaffAdminWorkspaceAssessmentsTemplateIdIndexRoute
  '/_staff/admin/workspace/assessments/assignments/': typeof StaffAdminWorkspaceAssessmentsAssignmentsIndexRoute
  '/_staff/admin/workspace/clients/$clientId/': typeof StaffAdminWorkspaceClientsClientIdIndexRoute
  '/_staff/admin/workspace/engagement/resources/': typeof StaffAdminWorkspaceEngagementResourcesIndexRoute
  '/_staff/admin/workspace/exercises/$id/': typeof StaffAdminWorkspaceExercisesIdIndexRoute
  '/_staff/admin/workspace/organizations/$orgId/': typeof StaffAdminWorkspaceOrganizationsOrgIdIndexRoute
  '/_staff/admin/workspace/practitioners/$practitionerId/': typeof StaffAdminWorkspacePractitionersPractitionerIdIndexRoute
  '/_staff/admin/workspace/clients/$clientId/exercises/$clientExerciseId': typeof StaffAdminWorkspaceClientsClientIdExercisesClientExerciseIdRoute
  '/_staff/admin/workspace/engagement/resources/$id/edit': typeof StaffAdminWorkspaceEngagementResourcesIdEditRoute
  '/_staff/admin/workspace/organizations/$orgId/locations/$locId': typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRouteWithChildren
  '/_staff/admin/workspace/organizations/$orgId/locations/new': typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsNewRoute
  '/_staff/admin/workspace/sessions/$sessionId/case-reports/$reportId': typeof StaffAdminWorkspaceSessionsSessionIdCaseReportsReportIdRoute
  '/_staff/admin/workspace/sessions/$sessionId/case-reports/new': typeof StaffAdminWorkspaceSessionsSessionIdCaseReportsNewRoute
  '/_staff/admin/workspace/engagement/resources/$id/': typeof StaffAdminWorkspaceEngagementResourcesIdIndexRoute
  '/_staff/admin/workspace/organizations/$orgId/locations/$locId/edit': typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdEditRoute
  '/_staff/admin/workspace/organizations/$orgId/locations/$locId/': typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/client'
    | '/not-found'
    | '/unauthorized'
    | '/client/call-now'
    | '/client/dashboard'
    | '/client/profile'
    | '/client/login'
    | '/forgot-password/sent'
    | '/invite/accept'
    | '/login/mfa'
    | '/login/mfa-setup'
    | '/reset-password/confirm'
    | '/sso/$slug'
    | '/app/'
    | '/forgot-password/'
    | '/invite/'
    | '/login/'
    | '/reset-password/'
    | '/verify-email/'
    | '/admin/platform'
    | '/admin/workspace'
    | '/app/assessments/$templateId'
    | '/app/case-reports/review-queue'
    | '/app/chat/$chatId'
    | '/app/clients/$clientId'
    | '/app/exercises/$id'
    | '/app/exercises/review-queue'
    | '/app/profile/edit'
    | '/app/red-flags/$id'
    | '/app/sessions/$sessionId'
    | '/app/sessions/book'
    | '/app/sessions/helpline'
    | '/auth/sso/land'
    | '/client/book/confirm'
    | '/client/book/details'
    | '/client/book/practitioner'
    | '/client/book/when'
    | '/client/chat/$chatId'
    | '/client/exercises/$clientExerciseId'
    | '/client/library/$resourceId'
    | '/client/library/bookmarks'
    | '/client/sessions/$sessionId'
    | '/client/forgot-password/sent'
    | '/client/register/sent'
    | '/app/assessments/'
    | '/app/availability/'
    | '/app/calendar/'
    | '/app/chat/'
    | '/app/clients/'
    | '/app/exercises/'
    | '/app/helpline-demand/'
    | '/app/profile/'
    | '/app/red-flags/'
    | '/app/sessions/'
    | '/app/telephony/'
    | '/client/assessments/'
    | '/client/book/'
    | '/client/chat/'
    | '/client/exercises/'
    | '/client/library/'
    | '/client/sessions/'
    | '/client/forgot-password/'
    | '/client/onboarding/'
    | '/client/register/'
    | '/org/portal/compliance'
    | '/org/portal/dashboard'
    | '/org/portal/statistics'
    | '/app/assessments/$templateId/assign'
    | '/app/assessments/$templateId/bulk-assign'
    | '/app/assessments/assignments/$assignmentId'
    | '/app/engagement/resources/$id'
    | '/app/sessions/$sessionId/note'
    | '/client/assessments/$assessmentId/$assignmentId'
    | '/client/book/success/$sessionId'
    | '/org/portal/'
    | '/admin/platform/'
    | '/admin/workspace/'
    | '/app/assessments/$templateId/'
    | '/app/assessments/assignments/'
    | '/app/clients/$clientId/'
    | '/app/engagement/resources/'
    | '/client/sessions/$sessionId/call'
    | '/app/sessions/$sessionId/call'
    | '/admin/platform/assessments/$templateId'
    | '/admin/platform/business-associates/$baId'
    | '/admin/platform/business-associates/new'
    | '/admin/platform/clients/$clientId'
    | '/admin/platform/organizations/$orgId'
    | '/admin/platform/practitioners/$practitionerId'
    | '/admin/platform/sessions/$sessionId'
    | '/admin/platform/telephony/agents'
    | '/admin/platform/telephony/did-mappings'
    | '/admin/platform/users/$userId'
    | '/admin/workspace/assessments/$templateId'
    | '/admin/workspace/assessments/new'
    | '/admin/workspace/clients/$clientId'
    | '/admin/workspace/exercises/$id'
    | '/admin/workspace/exercises/new'
    | '/admin/workspace/organizations/$orgId'
    | '/admin/workspace/organizations/new'
    | '/admin/workspace/practitioners/$practitionerId'
    | '/admin/workspace/red-flags/$id'
    | '/admin/workspace/sessions/$sessionId'
    | '/admin/workspace/sessions/book'
    | '/admin/workspace/telephony/agents'
    | '/admin/workspace/telephony/did-mappings'
    | '/admin/workspace/users/$userId'
    | '/admin/workspace/users/invite'
    | '/app/clients/$clientId/exercises/$clientExerciseId'
    | '/app/sessions/$sessionId/case-reports/$reportId'
    | '/app/sessions/$sessionId/case-reports/new'
    | '/client/assessments/$assessmentId/$assignmentId/result'
    | '/admin/platform/assessments/'
    | '/admin/platform/business-associates/'
    | '/admin/platform/clients/'
    | '/admin/platform/organizations/'
    | '/admin/platform/practitioners/'
    | '/admin/platform/red-flags/'
    | '/admin/platform/sessions/'
    | '/admin/platform/users/'
    | '/admin/workspace/assessments/'
    | '/admin/workspace/chats/'
    | '/admin/workspace/clients/'
    | '/admin/workspace/exercises/'
    | '/admin/workspace/helpline-demand/'
    | '/admin/workspace/organizations/'
    | '/admin/workspace/practitioners/'
    | '/admin/workspace/red-flags/'
    | '/admin/workspace/sessions/'
    | '/admin/workspace/telephony/'
    | '/admin/workspace/users/'
    | '/client/assessments/$assessmentId/$assignmentId/'
    | '/admin/workspace/sessions/$sessionId/call'
    | '/admin/platform/assessments/assignments/$assignmentId'
    | '/admin/platform/business-associates/$baId/edit'
    | '/admin/workspace/assessments/$templateId/assign'
    | '/admin/workspace/assessments/$templateId/bulk-assign'
    | '/admin/workspace/assessments/assignments/$assignmentId'
    | '/admin/workspace/clients/$clientId/edit'
    | '/admin/workspace/engagement/resources/$id'
    | '/admin/workspace/engagement/resources/new'
    | '/admin/workspace/exercises/$id/edit'
    | '/admin/workspace/organizations/$orgId/edit'
    | '/admin/workspace/practitioners/$practitionerId/edit'
    | '/admin/workspace/sessions/$sessionId/note'
    | '/admin/platform/assessments/$templateId/'
    | '/admin/platform/assessments/assignments/'
    | '/admin/platform/business-associates/$baId/'
    | '/admin/workspace/assessments/$templateId/'
    | '/admin/workspace/assessments/assignments/'
    | '/admin/workspace/clients/$clientId/'
    | '/admin/workspace/engagement/resources/'
    | '/admin/workspace/exercises/$id/'
    | '/admin/workspace/organizations/$orgId/'
    | '/admin/workspace/practitioners/$practitionerId/'
    | '/admin/workspace/clients/$clientId/exercises/$clientExerciseId'
    | '/admin/workspace/engagement/resources/$id/edit'
    | '/admin/workspace/organizations/$orgId/locations/$locId'
    | '/admin/workspace/organizations/$orgId/locations/new'
    | '/admin/workspace/sessions/$sessionId/case-reports/$reportId'
    | '/admin/workspace/sessions/$sessionId/case-reports/new'
    | '/admin/workspace/engagement/resources/$id/'
    | '/admin/workspace/organizations/$orgId/locations/$locId/edit'
    | '/admin/workspace/organizations/$orgId/locations/$locId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/client'
    | '/not-found'
    | '/unauthorized'
    | '/client/call-now'
    | '/client/dashboard'
    | '/client/profile'
    | '/client/login'
    | '/forgot-password/sent'
    | '/invite/accept'
    | '/login/mfa'
    | '/login/mfa-setup'
    | '/reset-password/confirm'
    | '/sso/$slug'
    | '/app'
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/reset-password'
    | '/verify-email'
    | '/app/case-reports/review-queue'
    | '/app/chat/$chatId'
    | '/app/exercises/$id'
    | '/app/exercises/review-queue'
    | '/app/profile/edit'
    | '/app/red-flags/$id'
    | '/app/sessions/$sessionId'
    | '/app/sessions/book'
    | '/app/sessions/helpline'
    | '/auth/sso/land'
    | '/client/book/confirm'
    | '/client/book/details'
    | '/client/book/practitioner'
    | '/client/book/when'
    | '/client/chat/$chatId'
    | '/client/exercises/$clientExerciseId'
    | '/client/library/$resourceId'
    | '/client/library/bookmarks'
    | '/client/sessions/$sessionId'
    | '/client/forgot-password/sent'
    | '/client/register/sent'
    | '/app/assessments'
    | '/app/availability'
    | '/app/calendar'
    | '/app/chat'
    | '/app/clients'
    | '/app/exercises'
    | '/app/helpline-demand'
    | '/app/profile'
    | '/app/red-flags'
    | '/app/sessions'
    | '/app/telephony'
    | '/client/assessments'
    | '/client/book'
    | '/client/chat'
    | '/client/exercises'
    | '/client/library'
    | '/client/sessions'
    | '/client/forgot-password'
    | '/client/onboarding'
    | '/client/register'
    | '/org/portal/compliance'
    | '/org/portal/dashboard'
    | '/org/portal/statistics'
    | '/app/assessments/$templateId/assign'
    | '/app/assessments/$templateId/bulk-assign'
    | '/app/assessments/assignments/$assignmentId'
    | '/app/engagement/resources/$id'
    | '/app/sessions/$sessionId/note'
    | '/client/book/success/$sessionId'
    | '/org/portal'
    | '/admin/platform'
    | '/admin/workspace'
    | '/app/assessments/$templateId'
    | '/app/assessments/assignments'
    | '/app/clients/$clientId'
    | '/app/engagement/resources'
    | '/client/sessions/$sessionId/call'
    | '/app/sessions/$sessionId/call'
    | '/admin/platform/business-associates/new'
    | '/admin/platform/clients/$clientId'
    | '/admin/platform/organizations/$orgId'
    | '/admin/platform/practitioners/$practitionerId'
    | '/admin/platform/sessions/$sessionId'
    | '/admin/platform/telephony/agents'
    | '/admin/platform/telephony/did-mappings'
    | '/admin/platform/users/$userId'
    | '/admin/workspace/assessments/new'
    | '/admin/workspace/exercises/new'
    | '/admin/workspace/organizations/new'
    | '/admin/workspace/red-flags/$id'
    | '/admin/workspace/sessions/$sessionId'
    | '/admin/workspace/sessions/book'
    | '/admin/workspace/telephony/agents'
    | '/admin/workspace/telephony/did-mappings'
    | '/admin/workspace/users/$userId'
    | '/admin/workspace/users/invite'
    | '/app/clients/$clientId/exercises/$clientExerciseId'
    | '/app/sessions/$sessionId/case-reports/$reportId'
    | '/app/sessions/$sessionId/case-reports/new'
    | '/client/assessments/$assessmentId/$assignmentId/result'
    | '/admin/platform/assessments'
    | '/admin/platform/business-associates'
    | '/admin/platform/clients'
    | '/admin/platform/organizations'
    | '/admin/platform/practitioners'
    | '/admin/platform/red-flags'
    | '/admin/platform/sessions'
    | '/admin/platform/users'
    | '/admin/workspace/assessments'
    | '/admin/workspace/chats'
    | '/admin/workspace/clients'
    | '/admin/workspace/exercises'
    | '/admin/workspace/helpline-demand'
    | '/admin/workspace/organizations'
    | '/admin/workspace/practitioners'
    | '/admin/workspace/red-flags'
    | '/admin/workspace/sessions'
    | '/admin/workspace/telephony'
    | '/admin/workspace/users'
    | '/client/assessments/$assessmentId/$assignmentId'
    | '/admin/workspace/sessions/$sessionId/call'
    | '/admin/platform/assessments/assignments/$assignmentId'
    | '/admin/platform/business-associates/$baId/edit'
    | '/admin/workspace/assessments/$templateId/assign'
    | '/admin/workspace/assessments/$templateId/bulk-assign'
    | '/admin/workspace/assessments/assignments/$assignmentId'
    | '/admin/workspace/clients/$clientId/edit'
    | '/admin/workspace/engagement/resources/new'
    | '/admin/workspace/exercises/$id/edit'
    | '/admin/workspace/organizations/$orgId/edit'
    | '/admin/workspace/practitioners/$practitionerId/edit'
    | '/admin/workspace/sessions/$sessionId/note'
    | '/admin/platform/assessments/$templateId'
    | '/admin/platform/assessments/assignments'
    | '/admin/platform/business-associates/$baId'
    | '/admin/workspace/assessments/$templateId'
    | '/admin/workspace/assessments/assignments'
    | '/admin/workspace/clients/$clientId'
    | '/admin/workspace/engagement/resources'
    | '/admin/workspace/exercises/$id'
    | '/admin/workspace/organizations/$orgId'
    | '/admin/workspace/practitioners/$practitionerId'
    | '/admin/workspace/clients/$clientId/exercises/$clientExerciseId'
    | '/admin/workspace/engagement/resources/$id/edit'
    | '/admin/workspace/organizations/$orgId/locations/new'
    | '/admin/workspace/sessions/$sessionId/case-reports/$reportId'
    | '/admin/workspace/sessions/$sessionId/case-reports/new'
    | '/admin/workspace/engagement/resources/$id'
    | '/admin/workspace/organizations/$orgId/locations/$locId/edit'
    | '/admin/workspace/organizations/$orgId/locations/$locId'
  id:
    | '__root__'
    | '/'
    | '/_client-fullscreen'
    | '/_org'
    | '/_staff-fullscreen'
    | '/app'
    | '/client'
    | '/not-found'
    | '/unauthorized'
    | '/client/call-now'
    | '/client/dashboard'
    | '/client/profile'
    | '/client_/login'
    | '/forgot-password/sent'
    | '/invite/accept'
    | '/login/mfa'
    | '/login/mfa-setup'
    | '/reset-password/confirm'
    | '/sso/$slug'
    | '/app/'
    | '/forgot-password/'
    | '/invite/'
    | '/login/'
    | '/reset-password/'
    | '/verify-email/'
    | '/_staff/admin/platform'
    | '/_staff/admin/workspace'
    | '/app/assessments/$templateId'
    | '/app/case-reports/review-queue'
    | '/app/chat/$chatId'
    | '/app/clients/$clientId'
    | '/app/exercises/$id'
    | '/app/exercises/review-queue'
    | '/app/profile/edit'
    | '/app/red-flags/$id'
    | '/app/sessions/$sessionId'
    | '/app/sessions/book'
    | '/app/sessions/helpline'
    | '/auth/sso/land'
    | '/client/book/confirm'
    | '/client/book/details'
    | '/client/book/practitioner'
    | '/client/book/when'
    | '/client/chat/$chatId'
    | '/client/exercises/$clientExerciseId'
    | '/client/library/$resourceId'
    | '/client/library/bookmarks'
    | '/client/sessions/$sessionId'
    | '/client_/forgot-password/sent'
    | '/client_/register/sent'
    | '/app/assessments/'
    | '/app/availability/'
    | '/app/calendar/'
    | '/app/chat/'
    | '/app/clients/'
    | '/app/exercises/'
    | '/app/helpline-demand/'
    | '/app/profile/'
    | '/app/red-flags/'
    | '/app/sessions/'
    | '/app/telephony/'
    | '/client/assessments/'
    | '/client/book/'
    | '/client/chat/'
    | '/client/exercises/'
    | '/client/library/'
    | '/client/sessions/'
    | '/client_/forgot-password/'
    | '/client_/onboarding/'
    | '/client_/register/'
    | '/_org/org/portal/compliance'
    | '/_org/org/portal/dashboard'
    | '/_org/org/portal/statistics'
    | '/app/assessments/$templateId/assign'
    | '/app/assessments/$templateId/bulk-assign'
    | '/app/assessments/assignments/$assignmentId'
    | '/app/engagement/resources/$id'
    | '/app/sessions/$sessionId/note'
    | '/client/assessments/$assessmentId/$assignmentId'
    | '/client/book/success/$sessionId'
    | '/_org/org/portal/'
    | '/_staff/admin/platform/'
    | '/_staff/admin/workspace/'
    | '/app/assessments/$templateId/'
    | '/app/assessments/assignments/'
    | '/app/clients/$clientId/'
    | '/app/engagement/resources/'
    | '/_client-fullscreen/client/sessions/$sessionId/call'
    | '/_staff-fullscreen/app/sessions/$sessionId/call'
    | '/_staff/admin/platform/assessments/$templateId'
    | '/_staff/admin/platform/business-associates/$baId'
    | '/_staff/admin/platform/business-associates/new'
    | '/_staff/admin/platform/clients/$clientId'
    | '/_staff/admin/platform/organizations/$orgId'
    | '/_staff/admin/platform/practitioners/$practitionerId'
    | '/_staff/admin/platform/sessions/$sessionId'
    | '/_staff/admin/platform/telephony/agents'
    | '/_staff/admin/platform/telephony/did-mappings'
    | '/_staff/admin/platform/users/$userId'
    | '/_staff/admin/workspace/assessments/$templateId'
    | '/_staff/admin/workspace/assessments/new'
    | '/_staff/admin/workspace/clients/$clientId'
    | '/_staff/admin/workspace/exercises/$id'
    | '/_staff/admin/workspace/exercises/new'
    | '/_staff/admin/workspace/organizations/$orgId'
    | '/_staff/admin/workspace/organizations/new'
    | '/_staff/admin/workspace/practitioners/$practitionerId'
    | '/_staff/admin/workspace/red-flags/$id'
    | '/_staff/admin/workspace/sessions/$sessionId'
    | '/_staff/admin/workspace/sessions/book'
    | '/_staff/admin/workspace/telephony/agents'
    | '/_staff/admin/workspace/telephony/did-mappings'
    | '/_staff/admin/workspace/users/$userId'
    | '/_staff/admin/workspace/users/invite'
    | '/app/clients/$clientId/exercises/$clientExerciseId'
    | '/app/sessions/$sessionId/case-reports/$reportId'
    | '/app/sessions/$sessionId/case-reports/new'
    | '/client/assessments/$assessmentId/$assignmentId/result'
    | '/_staff/admin/platform/assessments/'
    | '/_staff/admin/platform/business-associates/'
    | '/_staff/admin/platform/clients/'
    | '/_staff/admin/platform/organizations/'
    | '/_staff/admin/platform/practitioners/'
    | '/_staff/admin/platform/red-flags/'
    | '/_staff/admin/platform/sessions/'
    | '/_staff/admin/platform/users/'
    | '/_staff/admin/workspace/assessments/'
    | '/_staff/admin/workspace/chats/'
    | '/_staff/admin/workspace/clients/'
    | '/_staff/admin/workspace/exercises/'
    | '/_staff/admin/workspace/helpline-demand/'
    | '/_staff/admin/workspace/organizations/'
    | '/_staff/admin/workspace/practitioners/'
    | '/_staff/admin/workspace/red-flags/'
    | '/_staff/admin/workspace/sessions/'
    | '/_staff/admin/workspace/telephony/'
    | '/_staff/admin/workspace/users/'
    | '/client/assessments/$assessmentId/$assignmentId/'
    | '/_staff-fullscreen/admin/workspace/sessions/$sessionId/call'
    | '/_staff/admin/platform/assessments/assignments/$assignmentId'
    | '/_staff/admin/platform/business-associates/$baId/edit'
    | '/_staff/admin/workspace/assessments/$templateId/assign'
    | '/_staff/admin/workspace/assessments/$templateId/bulk-assign'
    | '/_staff/admin/workspace/assessments/assignments/$assignmentId'
    | '/_staff/admin/workspace/clients/$clientId/edit'
    | '/_staff/admin/workspace/engagement/resources/$id'
    | '/_staff/admin/workspace/engagement/resources/new'
    | '/_staff/admin/workspace/exercises/$id/edit'
    | '/_staff/admin/workspace/organizations/$orgId/edit'
    | '/_staff/admin/workspace/practitioners/$practitionerId/edit'
    | '/_staff/admin/workspace/sessions/$sessionId/note'
    | '/_staff/admin/platform/assessments/$templateId/'
    | '/_staff/admin/platform/assessments/assignments/'
    | '/_staff/admin/platform/business-associates/$baId/'
    | '/_staff/admin/workspace/assessments/$templateId/'
    | '/_staff/admin/workspace/assessments/assignments/'
    | '/_staff/admin/workspace/clients/$clientId/'
    | '/_staff/admin/workspace/engagement/resources/'
    | '/_staff/admin/workspace/exercises/$id/'
    | '/_staff/admin/workspace/organizations/$orgId/'
    | '/_staff/admin/workspace/practitioners/$practitionerId/'
    | '/_staff/admin/workspace/clients/$clientId/exercises/$clientExerciseId'
    | '/_staff/admin/workspace/engagement/resources/$id/edit'
    | '/_staff/admin/workspace/organizations/$orgId/locations/$locId'
    | '/_staff/admin/workspace/organizations/$orgId/locations/new'
    | '/_staff/admin/workspace/sessions/$sessionId/case-reports/$reportId'
    | '/_staff/admin/workspace/sessions/$sessionId/case-reports/new'
    | '/_staff/admin/workspace/engagement/resources/$id/'
    | '/_staff/admin/workspace/organizations/$orgId/locations/$locId/edit'
    | '/_staff/admin/workspace/organizations/$orgId/locations/$locId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ClientFullscreenRoute: typeof ClientFullscreenRouteWithChildren
  OrgRoute: typeof OrgRouteWithChildren
  StaffFullscreenRoute: typeof StaffFullscreenRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  ClientRoute: typeof ClientRouteWithChildren
  NotFoundRoute: typeof NotFoundRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
  ClientLoginRoute: typeof ClientLoginRoute
  ForgotPasswordSentRoute: typeof ForgotPasswordSentRoute
  InviteAcceptRoute: typeof InviteAcceptRoute
  LoginMfaRoute: typeof LoginMfaRoute
  LoginMfaSetupRoute: typeof LoginMfaSetupRoute
  ResetPasswordConfirmRoute: typeof ResetPasswordConfirmRoute
  SsoSlugRoute: typeof SsoSlugRoute
  ForgotPasswordIndexRoute: typeof ForgotPasswordIndexRoute
  InviteIndexRoute: typeof InviteIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  ResetPasswordIndexRoute: typeof ResetPasswordIndexRoute
  VerifyEmailIndexRoute: typeof VerifyEmailIndexRoute
  StaffAdminPlatformRoute: typeof StaffAdminPlatformRouteWithChildren
  StaffAdminWorkspaceRoute: typeof StaffAdminWorkspaceRouteWithChildren
  AuthSsoLandRoute: typeof AuthSsoLandRoute
  ClientForgotPasswordSentRoute: typeof ClientForgotPasswordSentRoute
  ClientRegisterSentRoute: typeof ClientRegisterSentRoute
  ClientForgotPasswordIndexRoute: typeof ClientForgotPasswordIndexRoute
  ClientOnboardingIndexRoute: typeof ClientOnboardingIndexRoute
  ClientRegisterIndexRoute: typeof ClientRegisterIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client': {
      id: '/client'
      path: '/client'
      fullPath: '/client'
      preLoaderRoute: typeof ClientRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_staff-fullscreen': {
      id: '/_staff-fullscreen'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof StaffFullscreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_org': {
      id: '/_org'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof OrgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_client-fullscreen': {
      id: '/_client-fullscreen'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ClientFullscreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email/': {
      id: '/verify-email/'
      path: '/verify-email'
      fullPath: '/verify-email/'
      preLoaderRoute: typeof VerifyEmailIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/': {
      id: '/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password/'
      preLoaderRoute: typeof ResetPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/': {
      id: '/invite/'
      path: '/invite'
      fullPath: '/invite/'
      preLoaderRoute: typeof InviteIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password/': {
      id: '/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password/'
      preLoaderRoute: typeof ForgotPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/sso/$slug': {
      id: '/sso/$slug'
      path: '/sso/$slug'
      fullPath: '/sso/$slug'
      preLoaderRoute: typeof SsoSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/confirm': {
      id: '/reset-password/confirm'
      path: '/reset-password/confirm'
      fullPath: '/reset-password/confirm'
      preLoaderRoute: typeof ResetPasswordConfirmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/mfa-setup': {
      id: '/login/mfa-setup'
      path: '/login/mfa-setup'
      fullPath: '/login/mfa-setup'
      preLoaderRoute: typeof LoginMfaSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/mfa': {
      id: '/login/mfa'
      path: '/login/mfa'
      fullPath: '/login/mfa'
      preLoaderRoute: typeof LoginMfaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/accept': {
      id: '/invite/accept'
      path: '/invite/accept'
      fullPath: '/invite/accept'
      preLoaderRoute: typeof InviteAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password/sent': {
      id: '/forgot-password/sent'
      path: '/forgot-password/sent'
      fullPath: '/forgot-password/sent'
      preLoaderRoute: typeof ForgotPasswordSentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client_/login': {
      id: '/client_/login'
      path: '/client/login'
      fullPath: '/client/login'
      preLoaderRoute: typeof ClientLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/profile': {
      id: '/client/profile'
      path: '/profile'
      fullPath: '/client/profile'
      preLoaderRoute: typeof ClientProfileRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/dashboard': {
      id: '/client/dashboard'
      path: '/dashboard'
      fullPath: '/client/dashboard'
      preLoaderRoute: typeof ClientDashboardRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/call-now': {
      id: '/client/call-now'
      path: '/call-now'
      fullPath: '/client/call-now'
      preLoaderRoute: typeof ClientCallNowRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client_/register/': {
      id: '/client_/register/'
      path: '/client/register'
      fullPath: '/client/register/'
      preLoaderRoute: typeof ClientRegisterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client_/onboarding/': {
      id: '/client_/onboarding/'
      path: '/client/onboarding'
      fullPath: '/client/onboarding/'
      preLoaderRoute: typeof ClientOnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client_/forgot-password/': {
      id: '/client_/forgot-password/'
      path: '/client/forgot-password'
      fullPath: '/client/forgot-password/'
      preLoaderRoute: typeof ClientForgotPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/sessions/': {
      id: '/client/sessions/'
      path: '/sessions'
      fullPath: '/client/sessions/'
      preLoaderRoute: typeof ClientSessionsIndexRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/library/': {
      id: '/client/library/'
      path: '/library'
      fullPath: '/client/library/'
      preLoaderRoute: typeof ClientLibraryIndexRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/exercises/': {
      id: '/client/exercises/'
      path: '/exercises'
      fullPath: '/client/exercises/'
      preLoaderRoute: typeof ClientExercisesIndexRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/chat/': {
      id: '/client/chat/'
      path: '/chat'
      fullPath: '/client/chat/'
      preLoaderRoute: typeof ClientChatIndexRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/book/': {
      id: '/client/book/'
      path: '/book'
      fullPath: '/client/book/'
      preLoaderRoute: typeof ClientBookIndexRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/assessments/': {
      id: '/client/assessments/'
      path: '/assessments'
      fullPath: '/client/assessments/'
      preLoaderRoute: typeof ClientAssessmentsIndexRouteImport
      parentRoute: typeof ClientRoute
    }
    '/app/telephony/': {
      id: '/app/telephony/'
      path: '/telephony'
      fullPath: '/app/telephony/'
      preLoaderRoute: typeof AppTelephonyIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/sessions/': {
      id: '/app/sessions/'
      path: '/sessions'
      fullPath: '/app/sessions/'
      preLoaderRoute: typeof AppSessionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/red-flags/': {
      id: '/app/red-flags/'
      path: '/red-flags'
      fullPath: '/app/red-flags/'
      preLoaderRoute: typeof AppRedFlagsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/profile/': {
      id: '/app/profile/'
      path: '/profile'
      fullPath: '/app/profile/'
      preLoaderRoute: typeof AppProfileIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/helpline-demand/': {
      id: '/app/helpline-demand/'
      path: '/helpline-demand'
      fullPath: '/app/helpline-demand/'
      preLoaderRoute: typeof AppHelplineDemandIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/exercises/': {
      id: '/app/exercises/'
      path: '/exercises'
      fullPath: '/app/exercises/'
      preLoaderRoute: typeof AppExercisesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/clients/': {
      id: '/app/clients/'
      path: '/clients'
      fullPath: '/app/clients/'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/chat/': {
      id: '/app/chat/'
      path: '/chat'
      fullPath: '/app/chat/'
      preLoaderRoute: typeof AppChatIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/calendar/': {
      id: '/app/calendar/'
      path: '/calendar'
      fullPath: '/app/calendar/'
      preLoaderRoute: typeof AppCalendarIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/availability/': {
      id: '/app/availability/'
      path: '/availability'
      fullPath: '/app/availability/'
      preLoaderRoute: typeof AppAvailabilityIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/assessments/': {
      id: '/app/assessments/'
      path: '/assessments'
      fullPath: '/app/assessments/'
      preLoaderRoute: typeof AppAssessmentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/client_/register/sent': {
      id: '/client_/register/sent'
      path: '/client/register/sent'
      fullPath: '/client/register/sent'
      preLoaderRoute: typeof ClientRegisterSentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client_/forgot-password/sent': {
      id: '/client_/forgot-password/sent'
      path: '/client/forgot-password/sent'
      fullPath: '/client/forgot-password/sent'
      preLoaderRoute: typeof ClientForgotPasswordSentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/sessions/$sessionId': {
      id: '/client/sessions/$sessionId'
      path: '/sessions/$sessionId'
      fullPath: '/client/sessions/$sessionId'
      preLoaderRoute: typeof ClientSessionsSessionIdRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/library/bookmarks': {
      id: '/client/library/bookmarks'
      path: '/library/bookmarks'
      fullPath: '/client/library/bookmarks'
      preLoaderRoute: typeof ClientLibraryBookmarksRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/library/$resourceId': {
      id: '/client/library/$resourceId'
      path: '/library/$resourceId'
      fullPath: '/client/library/$resourceId'
      preLoaderRoute: typeof ClientLibraryResourceIdRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/exercises/$clientExerciseId': {
      id: '/client/exercises/$clientExerciseId'
      path: '/exercises/$clientExerciseId'
      fullPath: '/client/exercises/$clientExerciseId'
      preLoaderRoute: typeof ClientExercisesClientExerciseIdRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/chat/$chatId': {
      id: '/client/chat/$chatId'
      path: '/chat/$chatId'
      fullPath: '/client/chat/$chatId'
      preLoaderRoute: typeof ClientChatChatIdRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/book/when': {
      id: '/client/book/when'
      path: '/book/when'
      fullPath: '/client/book/when'
      preLoaderRoute: typeof ClientBookWhenRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/book/practitioner': {
      id: '/client/book/practitioner'
      path: '/book/practitioner'
      fullPath: '/client/book/practitioner'
      preLoaderRoute: typeof ClientBookPractitionerRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/book/details': {
      id: '/client/book/details'
      path: '/book/details'
      fullPath: '/client/book/details'
      preLoaderRoute: typeof ClientBookDetailsRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/book/confirm': {
      id: '/client/book/confirm'
      path: '/book/confirm'
      fullPath: '/client/book/confirm'
      preLoaderRoute: typeof ClientBookConfirmRouteImport
      parentRoute: typeof ClientRoute
    }
    '/auth/sso/land': {
      id: '/auth/sso/land'
      path: '/auth/sso/land'
      fullPath: '/auth/sso/land'
      preLoaderRoute: typeof AuthSsoLandRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/sessions/helpline': {
      id: '/app/sessions/helpline'
      path: '/sessions/helpline'
      fullPath: '/app/sessions/helpline'
      preLoaderRoute: typeof AppSessionsHelplineRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/sessions/book': {
      id: '/app/sessions/book'
      path: '/sessions/book'
      fullPath: '/app/sessions/book'
      preLoaderRoute: typeof AppSessionsBookRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/sessions/$sessionId': {
      id: '/app/sessions/$sessionId'
      path: '/sessions/$sessionId'
      fullPath: '/app/sessions/$sessionId'
      preLoaderRoute: typeof AppSessionsSessionIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/red-flags/$id': {
      id: '/app/red-flags/$id'
      path: '/red-flags/$id'
      fullPath: '/app/red-flags/$id'
      preLoaderRoute: typeof AppRedFlagsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/profile/edit': {
      id: '/app/profile/edit'
      path: '/profile/edit'
      fullPath: '/app/profile/edit'
      preLoaderRoute: typeof AppProfileEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/exercises/review-queue': {
      id: '/app/exercises/review-queue'
      path: '/exercises/review-queue'
      fullPath: '/app/exercises/review-queue'
      preLoaderRoute: typeof AppExercisesReviewQueueRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/exercises/$id': {
      id: '/app/exercises/$id'
      path: '/exercises/$id'
      fullPath: '/app/exercises/$id'
      preLoaderRoute: typeof AppExercisesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/clients/$clientId': {
      id: '/app/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/app/clients/$clientId'
      preLoaderRoute: typeof AppClientsClientIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/chat/$chatId': {
      id: '/app/chat/$chatId'
      path: '/chat/$chatId'
      fullPath: '/app/chat/$chatId'
      preLoaderRoute: typeof AppChatChatIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/case-reports/review-queue': {
      id: '/app/case-reports/review-queue'
      path: '/case-reports/review-queue'
      fullPath: '/app/case-reports/review-queue'
      preLoaderRoute: typeof AppCaseReportsReviewQueueRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/assessments/$templateId': {
      id: '/app/assessments/$templateId'
      path: '/assessments/$templateId'
      fullPath: '/app/assessments/$templateId'
      preLoaderRoute: typeof AppAssessmentsTemplateIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_staff/admin/workspace': {
      id: '/_staff/admin/workspace'
      path: '/admin/workspace'
      fullPath: '/admin/workspace'
      preLoaderRoute: typeof StaffAdminWorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_staff/admin/platform': {
      id: '/_staff/admin/platform'
      path: '/admin/platform'
      fullPath: '/admin/platform'
      preLoaderRoute: typeof StaffAdminPlatformRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/engagement/resources/': {
      id: '/app/engagement/resources/'
      path: '/engagement/resources'
      fullPath: '/app/engagement/resources/'
      preLoaderRoute: typeof AppEngagementResourcesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/clients/$clientId/': {
      id: '/app/clients/$clientId/'
      path: '/'
      fullPath: '/app/clients/$clientId/'
      preLoaderRoute: typeof AppClientsClientIdIndexRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/app/assessments/assignments/': {
      id: '/app/assessments/assignments/'
      path: '/assessments/assignments'
      fullPath: '/app/assessments/assignments/'
      preLoaderRoute: typeof AppAssessmentsAssignmentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/assessments/$templateId/': {
      id: '/app/assessments/$templateId/'
      path: '/'
      fullPath: '/app/assessments/$templateId/'
      preLoaderRoute: typeof AppAssessmentsTemplateIdIndexRouteImport
      parentRoute: typeof AppAssessmentsTemplateIdRoute
    }
    '/_staff/admin/workspace/': {
      id: '/_staff/admin/workspace/'
      path: '/'
      fullPath: '/admin/workspace/'
      preLoaderRoute: typeof StaffAdminWorkspaceIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/platform/': {
      id: '/_staff/admin/platform/'
      path: '/'
      fullPath: '/admin/platform/'
      preLoaderRoute: typeof StaffAdminPlatformIndexRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_org/org/portal/': {
      id: '/_org/org/portal/'
      path: '/org/portal'
      fullPath: '/org/portal/'
      preLoaderRoute: typeof OrgOrgPortalIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/client/book/success/$sessionId': {
      id: '/client/book/success/$sessionId'
      path: '/book/success/$sessionId'
      fullPath: '/client/book/success/$sessionId'
      preLoaderRoute: typeof ClientBookSuccessSessionIdRouteImport
      parentRoute: typeof ClientRoute
    }
    '/client/assessments/$assessmentId/$assignmentId': {
      id: '/client/assessments/$assessmentId/$assignmentId'
      path: '/assessments/$assessmentId/$assignmentId'
      fullPath: '/client/assessments/$assessmentId/$assignmentId'
      preLoaderRoute: typeof ClientAssessmentsAssessmentIdAssignmentIdRouteImport
      parentRoute: typeof ClientRoute
    }
    '/app/sessions/$sessionId/note': {
      id: '/app/sessions/$sessionId/note'
      path: '/note'
      fullPath: '/app/sessions/$sessionId/note'
      preLoaderRoute: typeof AppSessionsSessionIdNoteRouteImport
      parentRoute: typeof AppSessionsSessionIdRoute
    }
    '/app/engagement/resources/$id': {
      id: '/app/engagement/resources/$id'
      path: '/engagement/resources/$id'
      fullPath: '/app/engagement/resources/$id'
      preLoaderRoute: typeof AppEngagementResourcesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/assessments/assignments/$assignmentId': {
      id: '/app/assessments/assignments/$assignmentId'
      path: '/assessments/assignments/$assignmentId'
      fullPath: '/app/assessments/assignments/$assignmentId'
      preLoaderRoute: typeof AppAssessmentsAssignmentsAssignmentIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/assessments/$templateId/bulk-assign': {
      id: '/app/assessments/$templateId/bulk-assign'
      path: '/bulk-assign'
      fullPath: '/app/assessments/$templateId/bulk-assign'
      preLoaderRoute: typeof AppAssessmentsTemplateIdBulkAssignRouteImport
      parentRoute: typeof AppAssessmentsTemplateIdRoute
    }
    '/app/assessments/$templateId/assign': {
      id: '/app/assessments/$templateId/assign'
      path: '/assign'
      fullPath: '/app/assessments/$templateId/assign'
      preLoaderRoute: typeof AppAssessmentsTemplateIdAssignRouteImport
      parentRoute: typeof AppAssessmentsTemplateIdRoute
    }
    '/_org/org/portal/statistics': {
      id: '/_org/org/portal/statistics'
      path: '/org/portal/statistics'
      fullPath: '/org/portal/statistics'
      preLoaderRoute: typeof OrgOrgPortalStatisticsRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/portal/dashboard': {
      id: '/_org/org/portal/dashboard'
      path: '/org/portal/dashboard'
      fullPath: '/org/portal/dashboard'
      preLoaderRoute: typeof OrgOrgPortalDashboardRouteImport
      parentRoute: typeof OrgRoute
    }
    '/_org/org/portal/compliance': {
      id: '/_org/org/portal/compliance'
      path: '/org/portal/compliance'
      fullPath: '/org/portal/compliance'
      preLoaderRoute: typeof OrgOrgPortalComplianceRouteImport
      parentRoute: typeof OrgRoute
    }
    '/client/assessments/$assessmentId/$assignmentId/': {
      id: '/client/assessments/$assessmentId/$assignmentId/'
      path: '/'
      fullPath: '/client/assessments/$assessmentId/$assignmentId/'
      preLoaderRoute: typeof ClientAssessmentsAssessmentIdAssignmentIdIndexRouteImport
      parentRoute: typeof ClientAssessmentsAssessmentIdAssignmentIdRoute
    }
    '/_staff/admin/workspace/users/': {
      id: '/_staff/admin/workspace/users/'
      path: '/users'
      fullPath: '/admin/workspace/users/'
      preLoaderRoute: typeof StaffAdminWorkspaceUsersIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/telephony/': {
      id: '/_staff/admin/workspace/telephony/'
      path: '/telephony'
      fullPath: '/admin/workspace/telephony/'
      preLoaderRoute: typeof StaffAdminWorkspaceTelephonyIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/sessions/': {
      id: '/_staff/admin/workspace/sessions/'
      path: '/sessions'
      fullPath: '/admin/workspace/sessions/'
      preLoaderRoute: typeof StaffAdminWorkspaceSessionsIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/red-flags/': {
      id: '/_staff/admin/workspace/red-flags/'
      path: '/red-flags'
      fullPath: '/admin/workspace/red-flags/'
      preLoaderRoute: typeof StaffAdminWorkspaceRedFlagsIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/practitioners/': {
      id: '/_staff/admin/workspace/practitioners/'
      path: '/practitioners'
      fullPath: '/admin/workspace/practitioners/'
      preLoaderRoute: typeof StaffAdminWorkspacePractitionersIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/organizations/': {
      id: '/_staff/admin/workspace/organizations/'
      path: '/organizations'
      fullPath: '/admin/workspace/organizations/'
      preLoaderRoute: typeof StaffAdminWorkspaceOrganizationsIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/helpline-demand/': {
      id: '/_staff/admin/workspace/helpline-demand/'
      path: '/helpline-demand'
      fullPath: '/admin/workspace/helpline-demand/'
      preLoaderRoute: typeof StaffAdminWorkspaceHelplineDemandIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/exercises/': {
      id: '/_staff/admin/workspace/exercises/'
      path: '/exercises'
      fullPath: '/admin/workspace/exercises/'
      preLoaderRoute: typeof StaffAdminWorkspaceExercisesIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/clients/': {
      id: '/_staff/admin/workspace/clients/'
      path: '/clients'
      fullPath: '/admin/workspace/clients/'
      preLoaderRoute: typeof StaffAdminWorkspaceClientsIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/chats/': {
      id: '/_staff/admin/workspace/chats/'
      path: '/chats'
      fullPath: '/admin/workspace/chats/'
      preLoaderRoute: typeof StaffAdminWorkspaceChatsIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/assessments/': {
      id: '/_staff/admin/workspace/assessments/'
      path: '/assessments'
      fullPath: '/admin/workspace/assessments/'
      preLoaderRoute: typeof StaffAdminWorkspaceAssessmentsIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/platform/users/': {
      id: '/_staff/admin/platform/users/'
      path: '/users'
      fullPath: '/admin/platform/users/'
      preLoaderRoute: typeof StaffAdminPlatformUsersIndexRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff/admin/platform/sessions/': {
      id: '/_staff/admin/platform/sessions/'
      path: '/sessions'
      fullPath: '/admin/platform/sessions/'
      preLoaderRoute: typeof StaffAdminPlatformSessionsIndexRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff/admin/platform/red-flags/': {
      id: '/_staff/admin/platform/red-flags/'
      path: '/red-flags'
      fullPath: '/admin/platform/red-flags/'
      preLoaderRoute: typeof StaffAdminPlatformRedFlagsIndexRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff/admin/platform/practitioners/': {
      id: '/_staff/admin/platform/practitioners/'
      path: '/practitioners'
      fullPath: '/admin/platform/practitioners/'
      preLoaderRoute: typeof StaffAdminPlatformPractitionersIndexRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff/admin/platform/organizations/': {
      id: '/_staff/admin/platform/organizations/'
      path: '/organizations'
      fullPath: '/admin/platform/organizations/'
      preLoaderRoute: typeof StaffAdminPlatformOrganizationsIndexRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff/admin/platform/clients/': {
      id: '/_staff/admin/platform/clients/'
      path: '/clients'
      fullPath: '/admin/platform/clients/'
      preLoaderRoute: typeof StaffAdminPlatformClientsIndexRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff/admin/platform/business-associates/': {
      id: '/_staff/admin/platform/business-associates/'
      path: '/business-associates'
      fullPath: '/admin/platform/business-associates/'
      preLoaderRoute: typeof StaffAdminPlatformBusinessAssociatesIndexRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff/admin/platform/assessments/': {
      id: '/_staff/admin/platform/assessments/'
      path: '/assessments'
      fullPath: '/admin/platform/assessments/'
      preLoaderRoute: typeof StaffAdminPlatformAssessmentsIndexRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/client/assessments/$assessmentId/$assignmentId/result': {
      id: '/client/assessments/$assessmentId/$assignmentId/result'
      path: '/result'
      fullPath: '/client/assessments/$assessmentId/$assignmentId/result'
      preLoaderRoute: typeof ClientAssessmentsAssessmentIdAssignmentIdResultRouteImport
      parentRoute: typeof ClientAssessmentsAssessmentIdAssignmentIdRoute
    }
    '/app/sessions/$sessionId/case-reports/new': {
      id: '/app/sessions/$sessionId/case-reports/new'
      path: '/case-reports/new'
      fullPath: '/app/sessions/$sessionId/case-reports/new'
      preLoaderRoute: typeof AppSessionsSessionIdCaseReportsNewRouteImport
      parentRoute: typeof AppSessionsSessionIdRoute
    }
    '/app/sessions/$sessionId/case-reports/$reportId': {
      id: '/app/sessions/$sessionId/case-reports/$reportId'
      path: '/case-reports/$reportId'
      fullPath: '/app/sessions/$sessionId/case-reports/$reportId'
      preLoaderRoute: typeof AppSessionsSessionIdCaseReportsReportIdRouteImport
      parentRoute: typeof AppSessionsSessionIdRoute
    }
    '/app/clients/$clientId/exercises/$clientExerciseId': {
      id: '/app/clients/$clientId/exercises/$clientExerciseId'
      path: '/exercises/$clientExerciseId'
      fullPath: '/app/clients/$clientId/exercises/$clientExerciseId'
      preLoaderRoute: typeof AppClientsClientIdExercisesClientExerciseIdRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/_staff/admin/workspace/users/invite': {
      id: '/_staff/admin/workspace/users/invite'
      path: '/users/invite'
      fullPath: '/admin/workspace/users/invite'
      preLoaderRoute: typeof StaffAdminWorkspaceUsersInviteRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/users/$userId': {
      id: '/_staff/admin/workspace/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/workspace/users/$userId'
      preLoaderRoute: typeof StaffAdminWorkspaceUsersUserIdRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/telephony/did-mappings': {
      id: '/_staff/admin/workspace/telephony/did-mappings'
      path: '/telephony/did-mappings'
      fullPath: '/admin/workspace/telephony/did-mappings'
      preLoaderRoute: typeof StaffAdminWorkspaceTelephonyDidMappingsRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/telephony/agents': {
      id: '/_staff/admin/workspace/telephony/agents'
      path: '/telephony/agents'
      fullPath: '/admin/workspace/telephony/agents'
      preLoaderRoute: typeof StaffAdminWorkspaceTelephonyAgentsRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/sessions/book': {
      id: '/_staff/admin/workspace/sessions/book'
      path: '/sessions/book'
      fullPath: '/admin/workspace/sessions/book'
      preLoaderRoute: typeof StaffAdminWorkspaceSessionsBookRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/sessions/$sessionId': {
      id: '/_staff/admin/workspace/sessions/$sessionId'
      path: '/sessions/$sessionId'
      fullPath: '/admin/workspace/sessions/$sessionId'
      preLoaderRoute: typeof StaffAdminWorkspaceSessionsSessionIdRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/red-flags/$id': {
      id: '/_staff/admin/workspace/red-flags/$id'
      path: '/red-flags/$id'
      fullPath: '/admin/workspace/red-flags/$id'
      preLoaderRoute: typeof StaffAdminWorkspaceRedFlagsIdRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/practitioners/$practitionerId': {
      id: '/_staff/admin/workspace/practitioners/$practitionerId'
      path: '/practitioners/$practitionerId'
      fullPath: '/admin/workspace/practitioners/$practitionerId'
      preLoaderRoute: typeof StaffAdminWorkspacePractitionersPractitionerIdRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/organizations/new': {
      id: '/_staff/admin/workspace/organizations/new'
      path: '/organizations/new'
      fullPath: '/admin/workspace/organizations/new'
      preLoaderRoute: typeof StaffAdminWorkspaceOrganizationsNewRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/organizations/$orgId': {
      id: '/_staff/admin/workspace/organizations/$orgId'
      path: '/organizations/$orgId'
      fullPath: '/admin/workspace/organizations/$orgId'
      preLoaderRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/exercises/new': {
      id: '/_staff/admin/workspace/exercises/new'
      path: '/exercises/new'
      fullPath: '/admin/workspace/exercises/new'
      preLoaderRoute: typeof StaffAdminWorkspaceExercisesNewRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/exercises/$id': {
      id: '/_staff/admin/workspace/exercises/$id'
      path: '/exercises/$id'
      fullPath: '/admin/workspace/exercises/$id'
      preLoaderRoute: typeof StaffAdminWorkspaceExercisesIdRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/clients/$clientId': {
      id: '/_staff/admin/workspace/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/admin/workspace/clients/$clientId'
      preLoaderRoute: typeof StaffAdminWorkspaceClientsClientIdRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/assessments/new': {
      id: '/_staff/admin/workspace/assessments/new'
      path: '/assessments/new'
      fullPath: '/admin/workspace/assessments/new'
      preLoaderRoute: typeof StaffAdminWorkspaceAssessmentsNewRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/assessments/$templateId': {
      id: '/_staff/admin/workspace/assessments/$templateId'
      path: '/assessments/$templateId'
      fullPath: '/admin/workspace/assessments/$templateId'
      preLoaderRoute: typeof StaffAdminWorkspaceAssessmentsTemplateIdRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/platform/users/$userId': {
      id: '/_staff/admin/platform/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/platform/users/$userId'
      preLoaderRoute: typeof StaffAdminPlatformUsersUserIdRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff/admin/platform/telephony/did-mappings': {
      id: '/_staff/admin/platform/telephony/did-mappings'
      path: '/telephony/did-mappings'
      fullPath: '/admin/platform/telephony/did-mappings'
      preLoaderRoute: typeof StaffAdminPlatformTelephonyDidMappingsRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff/admin/platform/telephony/agents': {
      id: '/_staff/admin/platform/telephony/agents'
      path: '/telephony/agents'
      fullPath: '/admin/platform/telephony/agents'
      preLoaderRoute: typeof StaffAdminPlatformTelephonyAgentsRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff/admin/platform/sessions/$sessionId': {
      id: '/_staff/admin/platform/sessions/$sessionId'
      path: '/sessions/$sessionId'
      fullPath: '/admin/platform/sessions/$sessionId'
      preLoaderRoute: typeof StaffAdminPlatformSessionsSessionIdRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff/admin/platform/practitioners/$practitionerId': {
      id: '/_staff/admin/platform/practitioners/$practitionerId'
      path: '/practitioners/$practitionerId'
      fullPath: '/admin/platform/practitioners/$practitionerId'
      preLoaderRoute: typeof StaffAdminPlatformPractitionersPractitionerIdRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff/admin/platform/organizations/$orgId': {
      id: '/_staff/admin/platform/organizations/$orgId'
      path: '/organizations/$orgId'
      fullPath: '/admin/platform/organizations/$orgId'
      preLoaderRoute: typeof StaffAdminPlatformOrganizationsOrgIdRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff/admin/platform/clients/$clientId': {
      id: '/_staff/admin/platform/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/admin/platform/clients/$clientId'
      preLoaderRoute: typeof StaffAdminPlatformClientsClientIdRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff/admin/platform/business-associates/new': {
      id: '/_staff/admin/platform/business-associates/new'
      path: '/business-associates/new'
      fullPath: '/admin/platform/business-associates/new'
      preLoaderRoute: typeof StaffAdminPlatformBusinessAssociatesNewRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff/admin/platform/business-associates/$baId': {
      id: '/_staff/admin/platform/business-associates/$baId'
      path: '/business-associates/$baId'
      fullPath: '/admin/platform/business-associates/$baId'
      preLoaderRoute: typeof StaffAdminPlatformBusinessAssociatesBaIdRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff/admin/platform/assessments/$templateId': {
      id: '/_staff/admin/platform/assessments/$templateId'
      path: '/assessments/$templateId'
      fullPath: '/admin/platform/assessments/$templateId'
      preLoaderRoute: typeof StaffAdminPlatformAssessmentsTemplateIdRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff-fullscreen/app/sessions/$sessionId/call': {
      id: '/_staff-fullscreen/app/sessions/$sessionId/call'
      path: '/app/sessions/$sessionId/call'
      fullPath: '/app/sessions/$sessionId/call'
      preLoaderRoute: typeof StaffFullscreenAppSessionsSessionIdCallRouteImport
      parentRoute: typeof StaffFullscreenRoute
    }
    '/_client-fullscreen/client/sessions/$sessionId/call': {
      id: '/_client-fullscreen/client/sessions/$sessionId/call'
      path: '/client/sessions/$sessionId/call'
      fullPath: '/client/sessions/$sessionId/call'
      preLoaderRoute: typeof ClientFullscreenClientSessionsSessionIdCallRouteImport
      parentRoute: typeof ClientFullscreenRoute
    }
    '/_staff/admin/workspace/practitioners/$practitionerId/': {
      id: '/_staff/admin/workspace/practitioners/$practitionerId/'
      path: '/'
      fullPath: '/admin/workspace/practitioners/$practitionerId/'
      preLoaderRoute: typeof StaffAdminWorkspacePractitionersPractitionerIdIndexRouteImport
      parentRoute: typeof StaffAdminWorkspacePractitionersPractitionerIdRoute
    }
    '/_staff/admin/workspace/organizations/$orgId/': {
      id: '/_staff/admin/workspace/organizations/$orgId/'
      path: '/'
      fullPath: '/admin/workspace/organizations/$orgId/'
      preLoaderRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdRoute
    }
    '/_staff/admin/workspace/exercises/$id/': {
      id: '/_staff/admin/workspace/exercises/$id/'
      path: '/'
      fullPath: '/admin/workspace/exercises/$id/'
      preLoaderRoute: typeof StaffAdminWorkspaceExercisesIdIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceExercisesIdRoute
    }
    '/_staff/admin/workspace/engagement/resources/': {
      id: '/_staff/admin/workspace/engagement/resources/'
      path: '/engagement/resources'
      fullPath: '/admin/workspace/engagement/resources/'
      preLoaderRoute: typeof StaffAdminWorkspaceEngagementResourcesIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/clients/$clientId/': {
      id: '/_staff/admin/workspace/clients/$clientId/'
      path: '/'
      fullPath: '/admin/workspace/clients/$clientId/'
      preLoaderRoute: typeof StaffAdminWorkspaceClientsClientIdIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceClientsClientIdRoute
    }
    '/_staff/admin/workspace/assessments/assignments/': {
      id: '/_staff/admin/workspace/assessments/assignments/'
      path: '/assessments/assignments'
      fullPath: '/admin/workspace/assessments/assignments/'
      preLoaderRoute: typeof StaffAdminWorkspaceAssessmentsAssignmentsIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/assessments/$templateId/': {
      id: '/_staff/admin/workspace/assessments/$templateId/'
      path: '/'
      fullPath: '/admin/workspace/assessments/$templateId/'
      preLoaderRoute: typeof StaffAdminWorkspaceAssessmentsTemplateIdIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceAssessmentsTemplateIdRoute
    }
    '/_staff/admin/platform/business-associates/$baId/': {
      id: '/_staff/admin/platform/business-associates/$baId/'
      path: '/'
      fullPath: '/admin/platform/business-associates/$baId/'
      preLoaderRoute: typeof StaffAdminPlatformBusinessAssociatesBaIdIndexRouteImport
      parentRoute: typeof StaffAdminPlatformBusinessAssociatesBaIdRoute
    }
    '/_staff/admin/platform/assessments/assignments/': {
      id: '/_staff/admin/platform/assessments/assignments/'
      path: '/assessments/assignments'
      fullPath: '/admin/platform/assessments/assignments/'
      preLoaderRoute: typeof StaffAdminPlatformAssessmentsAssignmentsIndexRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff/admin/platform/assessments/$templateId/': {
      id: '/_staff/admin/platform/assessments/$templateId/'
      path: '/'
      fullPath: '/admin/platform/assessments/$templateId/'
      preLoaderRoute: typeof StaffAdminPlatformAssessmentsTemplateIdIndexRouteImport
      parentRoute: typeof StaffAdminPlatformAssessmentsTemplateIdRoute
    }
    '/_staff/admin/workspace/sessions/$sessionId/note': {
      id: '/_staff/admin/workspace/sessions/$sessionId/note'
      path: '/note'
      fullPath: '/admin/workspace/sessions/$sessionId/note'
      preLoaderRoute: typeof StaffAdminWorkspaceSessionsSessionIdNoteRouteImport
      parentRoute: typeof StaffAdminWorkspaceSessionsSessionIdRoute
    }
    '/_staff/admin/workspace/practitioners/$practitionerId/edit': {
      id: '/_staff/admin/workspace/practitioners/$practitionerId/edit'
      path: '/edit'
      fullPath: '/admin/workspace/practitioners/$practitionerId/edit'
      preLoaderRoute: typeof StaffAdminWorkspacePractitionersPractitionerIdEditRouteImport
      parentRoute: typeof StaffAdminWorkspacePractitionersPractitionerIdRoute
    }
    '/_staff/admin/workspace/organizations/$orgId/edit': {
      id: '/_staff/admin/workspace/organizations/$orgId/edit'
      path: '/edit'
      fullPath: '/admin/workspace/organizations/$orgId/edit'
      preLoaderRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdEditRouteImport
      parentRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdRoute
    }
    '/_staff/admin/workspace/exercises/$id/edit': {
      id: '/_staff/admin/workspace/exercises/$id/edit'
      path: '/edit'
      fullPath: '/admin/workspace/exercises/$id/edit'
      preLoaderRoute: typeof StaffAdminWorkspaceExercisesIdEditRouteImport
      parentRoute: typeof StaffAdminWorkspaceExercisesIdRoute
    }
    '/_staff/admin/workspace/engagement/resources/new': {
      id: '/_staff/admin/workspace/engagement/resources/new'
      path: '/engagement/resources/new'
      fullPath: '/admin/workspace/engagement/resources/new'
      preLoaderRoute: typeof StaffAdminWorkspaceEngagementResourcesNewRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/engagement/resources/$id': {
      id: '/_staff/admin/workspace/engagement/resources/$id'
      path: '/engagement/resources/$id'
      fullPath: '/admin/workspace/engagement/resources/$id'
      preLoaderRoute: typeof StaffAdminWorkspaceEngagementResourcesIdRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/clients/$clientId/edit': {
      id: '/_staff/admin/workspace/clients/$clientId/edit'
      path: '/edit'
      fullPath: '/admin/workspace/clients/$clientId/edit'
      preLoaderRoute: typeof StaffAdminWorkspaceClientsClientIdEditRouteImport
      parentRoute: typeof StaffAdminWorkspaceClientsClientIdRoute
    }
    '/_staff/admin/workspace/assessments/assignments/$assignmentId': {
      id: '/_staff/admin/workspace/assessments/assignments/$assignmentId'
      path: '/assessments/assignments/$assignmentId'
      fullPath: '/admin/workspace/assessments/assignments/$assignmentId'
      preLoaderRoute: typeof StaffAdminWorkspaceAssessmentsAssignmentsAssignmentIdRouteImport
      parentRoute: typeof StaffAdminWorkspaceRoute
    }
    '/_staff/admin/workspace/assessments/$templateId/bulk-assign': {
      id: '/_staff/admin/workspace/assessments/$templateId/bulk-assign'
      path: '/bulk-assign'
      fullPath: '/admin/workspace/assessments/$templateId/bulk-assign'
      preLoaderRoute: typeof StaffAdminWorkspaceAssessmentsTemplateIdBulkAssignRouteImport
      parentRoute: typeof StaffAdminWorkspaceAssessmentsTemplateIdRoute
    }
    '/_staff/admin/workspace/assessments/$templateId/assign': {
      id: '/_staff/admin/workspace/assessments/$templateId/assign'
      path: '/assign'
      fullPath: '/admin/workspace/assessments/$templateId/assign'
      preLoaderRoute: typeof StaffAdminWorkspaceAssessmentsTemplateIdAssignRouteImport
      parentRoute: typeof StaffAdminWorkspaceAssessmentsTemplateIdRoute
    }
    '/_staff/admin/platform/business-associates/$baId/edit': {
      id: '/_staff/admin/platform/business-associates/$baId/edit'
      path: '/edit'
      fullPath: '/admin/platform/business-associates/$baId/edit'
      preLoaderRoute: typeof StaffAdminPlatformBusinessAssociatesBaIdEditRouteImport
      parentRoute: typeof StaffAdminPlatformBusinessAssociatesBaIdRoute
    }
    '/_staff/admin/platform/assessments/assignments/$assignmentId': {
      id: '/_staff/admin/platform/assessments/assignments/$assignmentId'
      path: '/assessments/assignments/$assignmentId'
      fullPath: '/admin/platform/assessments/assignments/$assignmentId'
      preLoaderRoute: typeof StaffAdminPlatformAssessmentsAssignmentsAssignmentIdRouteImport
      parentRoute: typeof StaffAdminPlatformRoute
    }
    '/_staff-fullscreen/admin/workspace/sessions/$sessionId/call': {
      id: '/_staff-fullscreen/admin/workspace/sessions/$sessionId/call'
      path: '/admin/workspace/sessions/$sessionId/call'
      fullPath: '/admin/workspace/sessions/$sessionId/call'
      preLoaderRoute: typeof StaffFullscreenAdminWorkspaceSessionsSessionIdCallRouteImport
      parentRoute: typeof StaffFullscreenRoute
    }
    '/_staff/admin/workspace/engagement/resources/$id/': {
      id: '/_staff/admin/workspace/engagement/resources/$id/'
      path: '/'
      fullPath: '/admin/workspace/engagement/resources/$id/'
      preLoaderRoute: typeof StaffAdminWorkspaceEngagementResourcesIdIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceEngagementResourcesIdRoute
    }
    '/_staff/admin/workspace/sessions/$sessionId/case-reports/new': {
      id: '/_staff/admin/workspace/sessions/$sessionId/case-reports/new'
      path: '/case-reports/new'
      fullPath: '/admin/workspace/sessions/$sessionId/case-reports/new'
      preLoaderRoute: typeof StaffAdminWorkspaceSessionsSessionIdCaseReportsNewRouteImport
      parentRoute: typeof StaffAdminWorkspaceSessionsSessionIdRoute
    }
    '/_staff/admin/workspace/sessions/$sessionId/case-reports/$reportId': {
      id: '/_staff/admin/workspace/sessions/$sessionId/case-reports/$reportId'
      path: '/case-reports/$reportId'
      fullPath: '/admin/workspace/sessions/$sessionId/case-reports/$reportId'
      preLoaderRoute: typeof StaffAdminWorkspaceSessionsSessionIdCaseReportsReportIdRouteImport
      parentRoute: typeof StaffAdminWorkspaceSessionsSessionIdRoute
    }
    '/_staff/admin/workspace/organizations/$orgId/locations/new': {
      id: '/_staff/admin/workspace/organizations/$orgId/locations/new'
      path: '/locations/new'
      fullPath: '/admin/workspace/organizations/$orgId/locations/new'
      preLoaderRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsNewRouteImport
      parentRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdRoute
    }
    '/_staff/admin/workspace/organizations/$orgId/locations/$locId': {
      id: '/_staff/admin/workspace/organizations/$orgId/locations/$locId'
      path: '/locations/$locId'
      fullPath: '/admin/workspace/organizations/$orgId/locations/$locId'
      preLoaderRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRouteImport
      parentRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdRoute
    }
    '/_staff/admin/workspace/engagement/resources/$id/edit': {
      id: '/_staff/admin/workspace/engagement/resources/$id/edit'
      path: '/edit'
      fullPath: '/admin/workspace/engagement/resources/$id/edit'
      preLoaderRoute: typeof StaffAdminWorkspaceEngagementResourcesIdEditRouteImport
      parentRoute: typeof StaffAdminWorkspaceEngagementResourcesIdRoute
    }
    '/_staff/admin/workspace/clients/$clientId/exercises/$clientExerciseId': {
      id: '/_staff/admin/workspace/clients/$clientId/exercises/$clientExerciseId'
      path: '/exercises/$clientExerciseId'
      fullPath: '/admin/workspace/clients/$clientId/exercises/$clientExerciseId'
      preLoaderRoute: typeof StaffAdminWorkspaceClientsClientIdExercisesClientExerciseIdRouteImport
      parentRoute: typeof StaffAdminWorkspaceClientsClientIdRoute
    }
    '/_staff/admin/workspace/organizations/$orgId/locations/$locId/': {
      id: '/_staff/admin/workspace/organizations/$orgId/locations/$locId/'
      path: '/'
      fullPath: '/admin/workspace/organizations/$orgId/locations/$locId/'
      preLoaderRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdIndexRouteImport
      parentRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRoute
    }
    '/_staff/admin/workspace/organizations/$orgId/locations/$locId/edit': {
      id: '/_staff/admin/workspace/organizations/$orgId/locations/$locId/edit'
      path: '/edit'
      fullPath: '/admin/workspace/organizations/$orgId/locations/$locId/edit'
      preLoaderRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdEditRouteImport
      parentRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRoute
    }
  }
}

interface ClientFullscreenRouteChildren {
  ClientFullscreenClientSessionsSessionIdCallRoute: typeof ClientFullscreenClientSessionsSessionIdCallRoute
}

const ClientFullscreenRouteChildren: ClientFullscreenRouteChildren = {
  ClientFullscreenClientSessionsSessionIdCallRoute:
    ClientFullscreenClientSessionsSessionIdCallRoute,
}

const ClientFullscreenRouteWithChildren =
  ClientFullscreenRoute._addFileChildren(ClientFullscreenRouteChildren)

interface OrgRouteChildren {
  OrgOrgPortalComplianceRoute: typeof OrgOrgPortalComplianceRoute
  OrgOrgPortalDashboardRoute: typeof OrgOrgPortalDashboardRoute
  OrgOrgPortalStatisticsRoute: typeof OrgOrgPortalStatisticsRoute
  OrgOrgPortalIndexRoute: typeof OrgOrgPortalIndexRoute
}

const OrgRouteChildren: OrgRouteChildren = {
  OrgOrgPortalComplianceRoute: OrgOrgPortalComplianceRoute,
  OrgOrgPortalDashboardRoute: OrgOrgPortalDashboardRoute,
  OrgOrgPortalStatisticsRoute: OrgOrgPortalStatisticsRoute,
  OrgOrgPortalIndexRoute: OrgOrgPortalIndexRoute,
}

const OrgRouteWithChildren = OrgRoute._addFileChildren(OrgRouteChildren)

interface StaffFullscreenRouteChildren {
  StaffFullscreenAppSessionsSessionIdCallRoute: typeof StaffFullscreenAppSessionsSessionIdCallRoute
  StaffFullscreenAdminWorkspaceSessionsSessionIdCallRoute: typeof StaffFullscreenAdminWorkspaceSessionsSessionIdCallRoute
}

const StaffFullscreenRouteChildren: StaffFullscreenRouteChildren = {
  StaffFullscreenAppSessionsSessionIdCallRoute:
    StaffFullscreenAppSessionsSessionIdCallRoute,
  StaffFullscreenAdminWorkspaceSessionsSessionIdCallRoute:
    StaffFullscreenAdminWorkspaceSessionsSessionIdCallRoute,
}

const StaffFullscreenRouteWithChildren = StaffFullscreenRoute._addFileChildren(
  StaffFullscreenRouteChildren,
)

interface AppAssessmentsTemplateIdRouteChildren {
  AppAssessmentsTemplateIdAssignRoute: typeof AppAssessmentsTemplateIdAssignRoute
  AppAssessmentsTemplateIdBulkAssignRoute: typeof AppAssessmentsTemplateIdBulkAssignRoute
  AppAssessmentsTemplateIdIndexRoute: typeof AppAssessmentsTemplateIdIndexRoute
}

const AppAssessmentsTemplateIdRouteChildren: AppAssessmentsTemplateIdRouteChildren =
  {
    AppAssessmentsTemplateIdAssignRoute: AppAssessmentsTemplateIdAssignRoute,
    AppAssessmentsTemplateIdBulkAssignRoute:
      AppAssessmentsTemplateIdBulkAssignRoute,
    AppAssessmentsTemplateIdIndexRoute: AppAssessmentsTemplateIdIndexRoute,
  }

const AppAssessmentsTemplateIdRouteWithChildren =
  AppAssessmentsTemplateIdRoute._addFileChildren(
    AppAssessmentsTemplateIdRouteChildren,
  )

interface AppClientsClientIdRouteChildren {
  AppClientsClientIdIndexRoute: typeof AppClientsClientIdIndexRoute
  AppClientsClientIdExercisesClientExerciseIdRoute: typeof AppClientsClientIdExercisesClientExerciseIdRoute
}

const AppClientsClientIdRouteChildren: AppClientsClientIdRouteChildren = {
  AppClientsClientIdIndexRoute: AppClientsClientIdIndexRoute,
  AppClientsClientIdExercisesClientExerciseIdRoute:
    AppClientsClientIdExercisesClientExerciseIdRoute,
}

const AppClientsClientIdRouteWithChildren =
  AppClientsClientIdRoute._addFileChildren(AppClientsClientIdRouteChildren)

interface AppSessionsSessionIdRouteChildren {
  AppSessionsSessionIdNoteRoute: typeof AppSessionsSessionIdNoteRoute
  AppSessionsSessionIdCaseReportsReportIdRoute: typeof AppSessionsSessionIdCaseReportsReportIdRoute
  AppSessionsSessionIdCaseReportsNewRoute: typeof AppSessionsSessionIdCaseReportsNewRoute
}

const AppSessionsSessionIdRouteChildren: AppSessionsSessionIdRouteChildren = {
  AppSessionsSessionIdNoteRoute: AppSessionsSessionIdNoteRoute,
  AppSessionsSessionIdCaseReportsReportIdRoute:
    AppSessionsSessionIdCaseReportsReportIdRoute,
  AppSessionsSessionIdCaseReportsNewRoute:
    AppSessionsSessionIdCaseReportsNewRoute,
}

const AppSessionsSessionIdRouteWithChildren =
  AppSessionsSessionIdRoute._addFileChildren(AppSessionsSessionIdRouteChildren)

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppAssessmentsTemplateIdRoute: typeof AppAssessmentsTemplateIdRouteWithChildren
  AppCaseReportsReviewQueueRoute: typeof AppCaseReportsReviewQueueRoute
  AppChatChatIdRoute: typeof AppChatChatIdRoute
  AppClientsClientIdRoute: typeof AppClientsClientIdRouteWithChildren
  AppExercisesIdRoute: typeof AppExercisesIdRoute
  AppExercisesReviewQueueRoute: typeof AppExercisesReviewQueueRoute
  AppProfileEditRoute: typeof AppProfileEditRoute
  AppRedFlagsIdRoute: typeof AppRedFlagsIdRoute
  AppSessionsSessionIdRoute: typeof AppSessionsSessionIdRouteWithChildren
  AppSessionsBookRoute: typeof AppSessionsBookRoute
  AppSessionsHelplineRoute: typeof AppSessionsHelplineRoute
  AppAssessmentsIndexRoute: typeof AppAssessmentsIndexRoute
  AppAvailabilityIndexRoute: typeof AppAvailabilityIndexRoute
  AppCalendarIndexRoute: typeof AppCalendarIndexRoute
  AppChatIndexRoute: typeof AppChatIndexRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
  AppExercisesIndexRoute: typeof AppExercisesIndexRoute
  AppHelplineDemandIndexRoute: typeof AppHelplineDemandIndexRoute
  AppProfileIndexRoute: typeof AppProfileIndexRoute
  AppRedFlagsIndexRoute: typeof AppRedFlagsIndexRoute
  AppSessionsIndexRoute: typeof AppSessionsIndexRoute
  AppTelephonyIndexRoute: typeof AppTelephonyIndexRoute
  AppAssessmentsAssignmentsAssignmentIdRoute: typeof AppAssessmentsAssignmentsAssignmentIdRoute
  AppEngagementResourcesIdRoute: typeof AppEngagementResourcesIdRoute
  AppAssessmentsAssignmentsIndexRoute: typeof AppAssessmentsAssignmentsIndexRoute
  AppEngagementResourcesIndexRoute: typeof AppEngagementResourcesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppAssessmentsTemplateIdRoute: AppAssessmentsTemplateIdRouteWithChildren,
  AppCaseReportsReviewQueueRoute: AppCaseReportsReviewQueueRoute,
  AppChatChatIdRoute: AppChatChatIdRoute,
  AppClientsClientIdRoute: AppClientsClientIdRouteWithChildren,
  AppExercisesIdRoute: AppExercisesIdRoute,
  AppExercisesReviewQueueRoute: AppExercisesReviewQueueRoute,
  AppProfileEditRoute: AppProfileEditRoute,
  AppRedFlagsIdRoute: AppRedFlagsIdRoute,
  AppSessionsSessionIdRoute: AppSessionsSessionIdRouteWithChildren,
  AppSessionsBookRoute: AppSessionsBookRoute,
  AppSessionsHelplineRoute: AppSessionsHelplineRoute,
  AppAssessmentsIndexRoute: AppAssessmentsIndexRoute,
  AppAvailabilityIndexRoute: AppAvailabilityIndexRoute,
  AppCalendarIndexRoute: AppCalendarIndexRoute,
  AppChatIndexRoute: AppChatIndexRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
  AppExercisesIndexRoute: AppExercisesIndexRoute,
  AppHelplineDemandIndexRoute: AppHelplineDemandIndexRoute,
  AppProfileIndexRoute: AppProfileIndexRoute,
  AppRedFlagsIndexRoute: AppRedFlagsIndexRoute,
  AppSessionsIndexRoute: AppSessionsIndexRoute,
  AppTelephonyIndexRoute: AppTelephonyIndexRoute,
  AppAssessmentsAssignmentsAssignmentIdRoute:
    AppAssessmentsAssignmentsAssignmentIdRoute,
  AppEngagementResourcesIdRoute: AppEngagementResourcesIdRoute,
  AppAssessmentsAssignmentsIndexRoute: AppAssessmentsAssignmentsIndexRoute,
  AppEngagementResourcesIndexRoute: AppEngagementResourcesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface ClientAssessmentsAssessmentIdAssignmentIdRouteChildren {
  ClientAssessmentsAssessmentIdAssignmentIdResultRoute: typeof ClientAssessmentsAssessmentIdAssignmentIdResultRoute
  ClientAssessmentsAssessmentIdAssignmentIdIndexRoute: typeof ClientAssessmentsAssessmentIdAssignmentIdIndexRoute
}

const ClientAssessmentsAssessmentIdAssignmentIdRouteChildren: ClientAssessmentsAssessmentIdAssignmentIdRouteChildren =
  {
    ClientAssessmentsAssessmentIdAssignmentIdResultRoute:
      ClientAssessmentsAssessmentIdAssignmentIdResultRoute,
    ClientAssessmentsAssessmentIdAssignmentIdIndexRoute:
      ClientAssessmentsAssessmentIdAssignmentIdIndexRoute,
  }

const ClientAssessmentsAssessmentIdAssignmentIdRouteWithChildren =
  ClientAssessmentsAssessmentIdAssignmentIdRoute._addFileChildren(
    ClientAssessmentsAssessmentIdAssignmentIdRouteChildren,
  )

interface ClientRouteChildren {
  ClientCallNowRoute: typeof ClientCallNowRoute
  ClientDashboardRoute: typeof ClientDashboardRoute
  ClientProfileRoute: typeof ClientProfileRoute
  ClientBookConfirmRoute: typeof ClientBookConfirmRoute
  ClientBookDetailsRoute: typeof ClientBookDetailsRoute
  ClientBookPractitionerRoute: typeof ClientBookPractitionerRoute
  ClientBookWhenRoute: typeof ClientBookWhenRoute
  ClientChatChatIdRoute: typeof ClientChatChatIdRoute
  ClientExercisesClientExerciseIdRoute: typeof ClientExercisesClientExerciseIdRoute
  ClientLibraryResourceIdRoute: typeof ClientLibraryResourceIdRoute
  ClientLibraryBookmarksRoute: typeof ClientLibraryBookmarksRoute
  ClientSessionsSessionIdRoute: typeof ClientSessionsSessionIdRoute
  ClientAssessmentsIndexRoute: typeof ClientAssessmentsIndexRoute
  ClientBookIndexRoute: typeof ClientBookIndexRoute
  ClientChatIndexRoute: typeof ClientChatIndexRoute
  ClientExercisesIndexRoute: typeof ClientExercisesIndexRoute
  ClientLibraryIndexRoute: typeof ClientLibraryIndexRoute
  ClientSessionsIndexRoute: typeof ClientSessionsIndexRoute
  ClientAssessmentsAssessmentIdAssignmentIdRoute: typeof ClientAssessmentsAssessmentIdAssignmentIdRouteWithChildren
  ClientBookSuccessSessionIdRoute: typeof ClientBookSuccessSessionIdRoute
}

const ClientRouteChildren: ClientRouteChildren = {
  ClientCallNowRoute: ClientCallNowRoute,
  ClientDashboardRoute: ClientDashboardRoute,
  ClientProfileRoute: ClientProfileRoute,
  ClientBookConfirmRoute: ClientBookConfirmRoute,
  ClientBookDetailsRoute: ClientBookDetailsRoute,
  ClientBookPractitionerRoute: ClientBookPractitionerRoute,
  ClientBookWhenRoute: ClientBookWhenRoute,
  ClientChatChatIdRoute: ClientChatChatIdRoute,
  ClientExercisesClientExerciseIdRoute: ClientExercisesClientExerciseIdRoute,
  ClientLibraryResourceIdRoute: ClientLibraryResourceIdRoute,
  ClientLibraryBookmarksRoute: ClientLibraryBookmarksRoute,
  ClientSessionsSessionIdRoute: ClientSessionsSessionIdRoute,
  ClientAssessmentsIndexRoute: ClientAssessmentsIndexRoute,
  ClientBookIndexRoute: ClientBookIndexRoute,
  ClientChatIndexRoute: ClientChatIndexRoute,
  ClientExercisesIndexRoute: ClientExercisesIndexRoute,
  ClientLibraryIndexRoute: ClientLibraryIndexRoute,
  ClientSessionsIndexRoute: ClientSessionsIndexRoute,
  ClientAssessmentsAssessmentIdAssignmentIdRoute:
    ClientAssessmentsAssessmentIdAssignmentIdRouteWithChildren,
  ClientBookSuccessSessionIdRoute: ClientBookSuccessSessionIdRoute,
}

const ClientRouteWithChildren =
  ClientRoute._addFileChildren(ClientRouteChildren)

interface StaffAdminPlatformAssessmentsTemplateIdRouteChildren {
  StaffAdminPlatformAssessmentsTemplateIdIndexRoute: typeof StaffAdminPlatformAssessmentsTemplateIdIndexRoute
}

const StaffAdminPlatformAssessmentsTemplateIdRouteChildren: StaffAdminPlatformAssessmentsTemplateIdRouteChildren =
  {
    StaffAdminPlatformAssessmentsTemplateIdIndexRoute:
      StaffAdminPlatformAssessmentsTemplateIdIndexRoute,
  }

const StaffAdminPlatformAssessmentsTemplateIdRouteWithChildren =
  StaffAdminPlatformAssessmentsTemplateIdRoute._addFileChildren(
    StaffAdminPlatformAssessmentsTemplateIdRouteChildren,
  )

interface StaffAdminPlatformBusinessAssociatesBaIdRouteChildren {
  StaffAdminPlatformBusinessAssociatesBaIdEditRoute: typeof StaffAdminPlatformBusinessAssociatesBaIdEditRoute
  StaffAdminPlatformBusinessAssociatesBaIdIndexRoute: typeof StaffAdminPlatformBusinessAssociatesBaIdIndexRoute
}

const StaffAdminPlatformBusinessAssociatesBaIdRouteChildren: StaffAdminPlatformBusinessAssociatesBaIdRouteChildren =
  {
    StaffAdminPlatformBusinessAssociatesBaIdEditRoute:
      StaffAdminPlatformBusinessAssociatesBaIdEditRoute,
    StaffAdminPlatformBusinessAssociatesBaIdIndexRoute:
      StaffAdminPlatformBusinessAssociatesBaIdIndexRoute,
  }

const StaffAdminPlatformBusinessAssociatesBaIdRouteWithChildren =
  StaffAdminPlatformBusinessAssociatesBaIdRoute._addFileChildren(
    StaffAdminPlatformBusinessAssociatesBaIdRouteChildren,
  )

interface StaffAdminPlatformRouteChildren {
  StaffAdminPlatformIndexRoute: typeof StaffAdminPlatformIndexRoute
  StaffAdminPlatformAssessmentsTemplateIdRoute: typeof StaffAdminPlatformAssessmentsTemplateIdRouteWithChildren
  StaffAdminPlatformBusinessAssociatesBaIdRoute: typeof StaffAdminPlatformBusinessAssociatesBaIdRouteWithChildren
  StaffAdminPlatformBusinessAssociatesNewRoute: typeof StaffAdminPlatformBusinessAssociatesNewRoute
  StaffAdminPlatformClientsClientIdRoute: typeof StaffAdminPlatformClientsClientIdRoute
  StaffAdminPlatformOrganizationsOrgIdRoute: typeof StaffAdminPlatformOrganizationsOrgIdRoute
  StaffAdminPlatformPractitionersPractitionerIdRoute: typeof StaffAdminPlatformPractitionersPractitionerIdRoute
  StaffAdminPlatformSessionsSessionIdRoute: typeof StaffAdminPlatformSessionsSessionIdRoute
  StaffAdminPlatformTelephonyAgentsRoute: typeof StaffAdminPlatformTelephonyAgentsRoute
  StaffAdminPlatformTelephonyDidMappingsRoute: typeof StaffAdminPlatformTelephonyDidMappingsRoute
  StaffAdminPlatformUsersUserIdRoute: typeof StaffAdminPlatformUsersUserIdRoute
  StaffAdminPlatformAssessmentsIndexRoute: typeof StaffAdminPlatformAssessmentsIndexRoute
  StaffAdminPlatformBusinessAssociatesIndexRoute: typeof StaffAdminPlatformBusinessAssociatesIndexRoute
  StaffAdminPlatformClientsIndexRoute: typeof StaffAdminPlatformClientsIndexRoute
  StaffAdminPlatformOrganizationsIndexRoute: typeof StaffAdminPlatformOrganizationsIndexRoute
  StaffAdminPlatformPractitionersIndexRoute: typeof StaffAdminPlatformPractitionersIndexRoute
  StaffAdminPlatformRedFlagsIndexRoute: typeof StaffAdminPlatformRedFlagsIndexRoute
  StaffAdminPlatformSessionsIndexRoute: typeof StaffAdminPlatformSessionsIndexRoute
  StaffAdminPlatformUsersIndexRoute: typeof StaffAdminPlatformUsersIndexRoute
  StaffAdminPlatformAssessmentsAssignmentsAssignmentIdRoute: typeof StaffAdminPlatformAssessmentsAssignmentsAssignmentIdRoute
  StaffAdminPlatformAssessmentsAssignmentsIndexRoute: typeof StaffAdminPlatformAssessmentsAssignmentsIndexRoute
}

const StaffAdminPlatformRouteChildren: StaffAdminPlatformRouteChildren = {
  StaffAdminPlatformIndexRoute: StaffAdminPlatformIndexRoute,
  StaffAdminPlatformAssessmentsTemplateIdRoute:
    StaffAdminPlatformAssessmentsTemplateIdRouteWithChildren,
  StaffAdminPlatformBusinessAssociatesBaIdRoute:
    StaffAdminPlatformBusinessAssociatesBaIdRouteWithChildren,
  StaffAdminPlatformBusinessAssociatesNewRoute:
    StaffAdminPlatformBusinessAssociatesNewRoute,
  StaffAdminPlatformClientsClientIdRoute:
    StaffAdminPlatformClientsClientIdRoute,
  StaffAdminPlatformOrganizationsOrgIdRoute:
    StaffAdminPlatformOrganizationsOrgIdRoute,
  StaffAdminPlatformPractitionersPractitionerIdRoute:
    StaffAdminPlatformPractitionersPractitionerIdRoute,
  StaffAdminPlatformSessionsSessionIdRoute:
    StaffAdminPlatformSessionsSessionIdRoute,
  StaffAdminPlatformTelephonyAgentsRoute:
    StaffAdminPlatformTelephonyAgentsRoute,
  StaffAdminPlatformTelephonyDidMappingsRoute:
    StaffAdminPlatformTelephonyDidMappingsRoute,
  StaffAdminPlatformUsersUserIdRoute: StaffAdminPlatformUsersUserIdRoute,
  StaffAdminPlatformAssessmentsIndexRoute:
    StaffAdminPlatformAssessmentsIndexRoute,
  StaffAdminPlatformBusinessAssociatesIndexRoute:
    StaffAdminPlatformBusinessAssociatesIndexRoute,
  StaffAdminPlatformClientsIndexRoute: StaffAdminPlatformClientsIndexRoute,
  StaffAdminPlatformOrganizationsIndexRoute:
    StaffAdminPlatformOrganizationsIndexRoute,
  StaffAdminPlatformPractitionersIndexRoute:
    StaffAdminPlatformPractitionersIndexRoute,
  StaffAdminPlatformRedFlagsIndexRoute: StaffAdminPlatformRedFlagsIndexRoute,
  StaffAdminPlatformSessionsIndexRoute: StaffAdminPlatformSessionsIndexRoute,
  StaffAdminPlatformUsersIndexRoute: StaffAdminPlatformUsersIndexRoute,
  StaffAdminPlatformAssessmentsAssignmentsAssignmentIdRoute:
    StaffAdminPlatformAssessmentsAssignmentsAssignmentIdRoute,
  StaffAdminPlatformAssessmentsAssignmentsIndexRoute:
    StaffAdminPlatformAssessmentsAssignmentsIndexRoute,
}

const StaffAdminPlatformRouteWithChildren =
  StaffAdminPlatformRoute._addFileChildren(StaffAdminPlatformRouteChildren)

interface StaffAdminWorkspaceAssessmentsTemplateIdRouteChildren {
  StaffAdminWorkspaceAssessmentsTemplateIdAssignRoute: typeof StaffAdminWorkspaceAssessmentsTemplateIdAssignRoute
  StaffAdminWorkspaceAssessmentsTemplateIdBulkAssignRoute: typeof StaffAdminWorkspaceAssessmentsTemplateIdBulkAssignRoute
  StaffAdminWorkspaceAssessmentsTemplateIdIndexRoute: typeof StaffAdminWorkspaceAssessmentsTemplateIdIndexRoute
}

const StaffAdminWorkspaceAssessmentsTemplateIdRouteChildren: StaffAdminWorkspaceAssessmentsTemplateIdRouteChildren =
  {
    StaffAdminWorkspaceAssessmentsTemplateIdAssignRoute:
      StaffAdminWorkspaceAssessmentsTemplateIdAssignRoute,
    StaffAdminWorkspaceAssessmentsTemplateIdBulkAssignRoute:
      StaffAdminWorkspaceAssessmentsTemplateIdBulkAssignRoute,
    StaffAdminWorkspaceAssessmentsTemplateIdIndexRoute:
      StaffAdminWorkspaceAssessmentsTemplateIdIndexRoute,
  }

const StaffAdminWorkspaceAssessmentsTemplateIdRouteWithChildren =
  StaffAdminWorkspaceAssessmentsTemplateIdRoute._addFileChildren(
    StaffAdminWorkspaceAssessmentsTemplateIdRouteChildren,
  )

interface StaffAdminWorkspaceClientsClientIdRouteChildren {
  StaffAdminWorkspaceClientsClientIdEditRoute: typeof StaffAdminWorkspaceClientsClientIdEditRoute
  StaffAdminWorkspaceClientsClientIdIndexRoute: typeof StaffAdminWorkspaceClientsClientIdIndexRoute
  StaffAdminWorkspaceClientsClientIdExercisesClientExerciseIdRoute: typeof StaffAdminWorkspaceClientsClientIdExercisesClientExerciseIdRoute
}

const StaffAdminWorkspaceClientsClientIdRouteChildren: StaffAdminWorkspaceClientsClientIdRouteChildren =
  {
    StaffAdminWorkspaceClientsClientIdEditRoute:
      StaffAdminWorkspaceClientsClientIdEditRoute,
    StaffAdminWorkspaceClientsClientIdIndexRoute:
      StaffAdminWorkspaceClientsClientIdIndexRoute,
    StaffAdminWorkspaceClientsClientIdExercisesClientExerciseIdRoute:
      StaffAdminWorkspaceClientsClientIdExercisesClientExerciseIdRoute,
  }

const StaffAdminWorkspaceClientsClientIdRouteWithChildren =
  StaffAdminWorkspaceClientsClientIdRoute._addFileChildren(
    StaffAdminWorkspaceClientsClientIdRouteChildren,
  )

interface StaffAdminWorkspaceExercisesIdRouteChildren {
  StaffAdminWorkspaceExercisesIdEditRoute: typeof StaffAdminWorkspaceExercisesIdEditRoute
  StaffAdminWorkspaceExercisesIdIndexRoute: typeof StaffAdminWorkspaceExercisesIdIndexRoute
}

const StaffAdminWorkspaceExercisesIdRouteChildren: StaffAdminWorkspaceExercisesIdRouteChildren =
  {
    StaffAdminWorkspaceExercisesIdEditRoute:
      StaffAdminWorkspaceExercisesIdEditRoute,
    StaffAdminWorkspaceExercisesIdIndexRoute:
      StaffAdminWorkspaceExercisesIdIndexRoute,
  }

const StaffAdminWorkspaceExercisesIdRouteWithChildren =
  StaffAdminWorkspaceExercisesIdRoute._addFileChildren(
    StaffAdminWorkspaceExercisesIdRouteChildren,
  )

interface StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRouteChildren {
  StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdEditRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdEditRoute
  StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdIndexRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdIndexRoute
}

const StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRouteChildren: StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRouteChildren =
  {
    StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdEditRoute:
      StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdEditRoute,
    StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdIndexRoute:
      StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdIndexRoute,
  }

const StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRouteWithChildren =
  StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRoute._addFileChildren(
    StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRouteChildren,
  )

interface StaffAdminWorkspaceOrganizationsOrgIdRouteChildren {
  StaffAdminWorkspaceOrganizationsOrgIdEditRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdEditRoute
  StaffAdminWorkspaceOrganizationsOrgIdIndexRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdIndexRoute
  StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRouteWithChildren
  StaffAdminWorkspaceOrganizationsOrgIdLocationsNewRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdLocationsNewRoute
}

const StaffAdminWorkspaceOrganizationsOrgIdRouteChildren: StaffAdminWorkspaceOrganizationsOrgIdRouteChildren =
  {
    StaffAdminWorkspaceOrganizationsOrgIdEditRoute:
      StaffAdminWorkspaceOrganizationsOrgIdEditRoute,
    StaffAdminWorkspaceOrganizationsOrgIdIndexRoute:
      StaffAdminWorkspaceOrganizationsOrgIdIndexRoute,
    StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRoute:
      StaffAdminWorkspaceOrganizationsOrgIdLocationsLocIdRouteWithChildren,
    StaffAdminWorkspaceOrganizationsOrgIdLocationsNewRoute:
      StaffAdminWorkspaceOrganizationsOrgIdLocationsNewRoute,
  }

const StaffAdminWorkspaceOrganizationsOrgIdRouteWithChildren =
  StaffAdminWorkspaceOrganizationsOrgIdRoute._addFileChildren(
    StaffAdminWorkspaceOrganizationsOrgIdRouteChildren,
  )

interface StaffAdminWorkspacePractitionersPractitionerIdRouteChildren {
  StaffAdminWorkspacePractitionersPractitionerIdEditRoute: typeof StaffAdminWorkspacePractitionersPractitionerIdEditRoute
  StaffAdminWorkspacePractitionersPractitionerIdIndexRoute: typeof StaffAdminWorkspacePractitionersPractitionerIdIndexRoute
}

const StaffAdminWorkspacePractitionersPractitionerIdRouteChildren: StaffAdminWorkspacePractitionersPractitionerIdRouteChildren =
  {
    StaffAdminWorkspacePractitionersPractitionerIdEditRoute:
      StaffAdminWorkspacePractitionersPractitionerIdEditRoute,
    StaffAdminWorkspacePractitionersPractitionerIdIndexRoute:
      StaffAdminWorkspacePractitionersPractitionerIdIndexRoute,
  }

const StaffAdminWorkspacePractitionersPractitionerIdRouteWithChildren =
  StaffAdminWorkspacePractitionersPractitionerIdRoute._addFileChildren(
    StaffAdminWorkspacePractitionersPractitionerIdRouteChildren,
  )

interface StaffAdminWorkspaceSessionsSessionIdRouteChildren {
  StaffAdminWorkspaceSessionsSessionIdNoteRoute: typeof StaffAdminWorkspaceSessionsSessionIdNoteRoute
  StaffAdminWorkspaceSessionsSessionIdCaseReportsReportIdRoute: typeof StaffAdminWorkspaceSessionsSessionIdCaseReportsReportIdRoute
  StaffAdminWorkspaceSessionsSessionIdCaseReportsNewRoute: typeof StaffAdminWorkspaceSessionsSessionIdCaseReportsNewRoute
}

const StaffAdminWorkspaceSessionsSessionIdRouteChildren: StaffAdminWorkspaceSessionsSessionIdRouteChildren =
  {
    StaffAdminWorkspaceSessionsSessionIdNoteRoute:
      StaffAdminWorkspaceSessionsSessionIdNoteRoute,
    StaffAdminWorkspaceSessionsSessionIdCaseReportsReportIdRoute:
      StaffAdminWorkspaceSessionsSessionIdCaseReportsReportIdRoute,
    StaffAdminWorkspaceSessionsSessionIdCaseReportsNewRoute:
      StaffAdminWorkspaceSessionsSessionIdCaseReportsNewRoute,
  }

const StaffAdminWorkspaceSessionsSessionIdRouteWithChildren =
  StaffAdminWorkspaceSessionsSessionIdRoute._addFileChildren(
    StaffAdminWorkspaceSessionsSessionIdRouteChildren,
  )

interface StaffAdminWorkspaceEngagementResourcesIdRouteChildren {
  StaffAdminWorkspaceEngagementResourcesIdEditRoute: typeof StaffAdminWorkspaceEngagementResourcesIdEditRoute
  StaffAdminWorkspaceEngagementResourcesIdIndexRoute: typeof StaffAdminWorkspaceEngagementResourcesIdIndexRoute
}

const StaffAdminWorkspaceEngagementResourcesIdRouteChildren: StaffAdminWorkspaceEngagementResourcesIdRouteChildren =
  {
    StaffAdminWorkspaceEngagementResourcesIdEditRoute:
      StaffAdminWorkspaceEngagementResourcesIdEditRoute,
    StaffAdminWorkspaceEngagementResourcesIdIndexRoute:
      StaffAdminWorkspaceEngagementResourcesIdIndexRoute,
  }

const StaffAdminWorkspaceEngagementResourcesIdRouteWithChildren =
  StaffAdminWorkspaceEngagementResourcesIdRoute._addFileChildren(
    StaffAdminWorkspaceEngagementResourcesIdRouteChildren,
  )

interface StaffAdminWorkspaceRouteChildren {
  StaffAdminWorkspaceIndexRoute: typeof StaffAdminWorkspaceIndexRoute
  StaffAdminWorkspaceAssessmentsTemplateIdRoute: typeof StaffAdminWorkspaceAssessmentsTemplateIdRouteWithChildren
  StaffAdminWorkspaceAssessmentsNewRoute: typeof StaffAdminWorkspaceAssessmentsNewRoute
  StaffAdminWorkspaceClientsClientIdRoute: typeof StaffAdminWorkspaceClientsClientIdRouteWithChildren
  StaffAdminWorkspaceExercisesIdRoute: typeof StaffAdminWorkspaceExercisesIdRouteWithChildren
  StaffAdminWorkspaceExercisesNewRoute: typeof StaffAdminWorkspaceExercisesNewRoute
  StaffAdminWorkspaceOrganizationsOrgIdRoute: typeof StaffAdminWorkspaceOrganizationsOrgIdRouteWithChildren
  StaffAdminWorkspaceOrganizationsNewRoute: typeof StaffAdminWorkspaceOrganizationsNewRoute
  StaffAdminWorkspacePractitionersPractitionerIdRoute: typeof StaffAdminWorkspacePractitionersPractitionerIdRouteWithChildren
  StaffAdminWorkspaceRedFlagsIdRoute: typeof StaffAdminWorkspaceRedFlagsIdRoute
  StaffAdminWorkspaceSessionsSessionIdRoute: typeof StaffAdminWorkspaceSessionsSessionIdRouteWithChildren
  StaffAdminWorkspaceSessionsBookRoute: typeof StaffAdminWorkspaceSessionsBookRoute
  StaffAdminWorkspaceTelephonyAgentsRoute: typeof StaffAdminWorkspaceTelephonyAgentsRoute
  StaffAdminWorkspaceTelephonyDidMappingsRoute: typeof StaffAdminWorkspaceTelephonyDidMappingsRoute
  StaffAdminWorkspaceUsersUserIdRoute: typeof StaffAdminWorkspaceUsersUserIdRoute
  StaffAdminWorkspaceUsersInviteRoute: typeof StaffAdminWorkspaceUsersInviteRoute
  StaffAdminWorkspaceAssessmentsIndexRoute: typeof StaffAdminWorkspaceAssessmentsIndexRoute
  StaffAdminWorkspaceChatsIndexRoute: typeof StaffAdminWorkspaceChatsIndexRoute
  StaffAdminWorkspaceClientsIndexRoute: typeof StaffAdminWorkspaceClientsIndexRoute
  StaffAdminWorkspaceExercisesIndexRoute: typeof StaffAdminWorkspaceExercisesIndexRoute
  StaffAdminWorkspaceHelplineDemandIndexRoute: typeof StaffAdminWorkspaceHelplineDemandIndexRoute
  StaffAdminWorkspaceOrganizationsIndexRoute: typeof StaffAdminWorkspaceOrganizationsIndexRoute
  StaffAdminWorkspacePractitionersIndexRoute: typeof StaffAdminWorkspacePractitionersIndexRoute
  StaffAdminWorkspaceRedFlagsIndexRoute: typeof StaffAdminWorkspaceRedFlagsIndexRoute
  StaffAdminWorkspaceSessionsIndexRoute: typeof StaffAdminWorkspaceSessionsIndexRoute
  StaffAdminWorkspaceTelephonyIndexRoute: typeof StaffAdminWorkspaceTelephonyIndexRoute
  StaffAdminWorkspaceUsersIndexRoute: typeof StaffAdminWorkspaceUsersIndexRoute
  StaffAdminWorkspaceAssessmentsAssignmentsAssignmentIdRoute: typeof StaffAdminWorkspaceAssessmentsAssignmentsAssignmentIdRoute
  StaffAdminWorkspaceEngagementResourcesIdRoute: typeof StaffAdminWorkspaceEngagementResourcesIdRouteWithChildren
  StaffAdminWorkspaceEngagementResourcesNewRoute: typeof StaffAdminWorkspaceEngagementResourcesNewRoute
  StaffAdminWorkspaceAssessmentsAssignmentsIndexRoute: typeof StaffAdminWorkspaceAssessmentsAssignmentsIndexRoute
  StaffAdminWorkspaceEngagementResourcesIndexRoute: typeof StaffAdminWorkspaceEngagementResourcesIndexRoute
}

const StaffAdminWorkspaceRouteChildren: StaffAdminWorkspaceRouteChildren = {
  StaffAdminWorkspaceIndexRoute: StaffAdminWorkspaceIndexRoute,
  StaffAdminWorkspaceAssessmentsTemplateIdRoute:
    StaffAdminWorkspaceAssessmentsTemplateIdRouteWithChildren,
  StaffAdminWorkspaceAssessmentsNewRoute:
    StaffAdminWorkspaceAssessmentsNewRoute,
  StaffAdminWorkspaceClientsClientIdRoute:
    StaffAdminWorkspaceClientsClientIdRouteWithChildren,
  StaffAdminWorkspaceExercisesIdRoute:
    StaffAdminWorkspaceExercisesIdRouteWithChildren,
  StaffAdminWorkspaceExercisesNewRoute: StaffAdminWorkspaceExercisesNewRoute,
  StaffAdminWorkspaceOrganizationsOrgIdRoute:
    StaffAdminWorkspaceOrganizationsOrgIdRouteWithChildren,
  StaffAdminWorkspaceOrganizationsNewRoute:
    StaffAdminWorkspaceOrganizationsNewRoute,
  StaffAdminWorkspacePractitionersPractitionerIdRoute:
    StaffAdminWorkspacePractitionersPractitionerIdRouteWithChildren,
  StaffAdminWorkspaceRedFlagsIdRoute: StaffAdminWorkspaceRedFlagsIdRoute,
  StaffAdminWorkspaceSessionsSessionIdRoute:
    StaffAdminWorkspaceSessionsSessionIdRouteWithChildren,
  StaffAdminWorkspaceSessionsBookRoute: StaffAdminWorkspaceSessionsBookRoute,
  StaffAdminWorkspaceTelephonyAgentsRoute:
    StaffAdminWorkspaceTelephonyAgentsRoute,
  StaffAdminWorkspaceTelephonyDidMappingsRoute:
    StaffAdminWorkspaceTelephonyDidMappingsRoute,
  StaffAdminWorkspaceUsersUserIdRoute: StaffAdminWorkspaceUsersUserIdRoute,
  StaffAdminWorkspaceUsersInviteRoute: StaffAdminWorkspaceUsersInviteRoute,
  StaffAdminWorkspaceAssessmentsIndexRoute:
    StaffAdminWorkspaceAssessmentsIndexRoute,
  StaffAdminWorkspaceChatsIndexRoute: StaffAdminWorkspaceChatsIndexRoute,
  StaffAdminWorkspaceClientsIndexRoute: StaffAdminWorkspaceClientsIndexRoute,
  StaffAdminWorkspaceExercisesIndexRoute:
    StaffAdminWorkspaceExercisesIndexRoute,
  StaffAdminWorkspaceHelplineDemandIndexRoute:
    StaffAdminWorkspaceHelplineDemandIndexRoute,
  StaffAdminWorkspaceOrganizationsIndexRoute:
    StaffAdminWorkspaceOrganizationsIndexRoute,
  StaffAdminWorkspacePractitionersIndexRoute:
    StaffAdminWorkspacePractitionersIndexRoute,
  StaffAdminWorkspaceRedFlagsIndexRoute: StaffAdminWorkspaceRedFlagsIndexRoute,
  StaffAdminWorkspaceSessionsIndexRoute: StaffAdminWorkspaceSessionsIndexRoute,
  StaffAdminWorkspaceTelephonyIndexRoute:
    StaffAdminWorkspaceTelephonyIndexRoute,
  StaffAdminWorkspaceUsersIndexRoute: StaffAdminWorkspaceUsersIndexRoute,
  StaffAdminWorkspaceAssessmentsAssignmentsAssignmentIdRoute:
    StaffAdminWorkspaceAssessmentsAssignmentsAssignmentIdRoute,
  StaffAdminWorkspaceEngagementResourcesIdRoute:
    StaffAdminWorkspaceEngagementResourcesIdRouteWithChildren,
  StaffAdminWorkspaceEngagementResourcesNewRoute:
    StaffAdminWorkspaceEngagementResourcesNewRoute,
  StaffAdminWorkspaceAssessmentsAssignmentsIndexRoute:
    StaffAdminWorkspaceAssessmentsAssignmentsIndexRoute,
  StaffAdminWorkspaceEngagementResourcesIndexRoute:
    StaffAdminWorkspaceEngagementResourcesIndexRoute,
}

const StaffAdminWorkspaceRouteWithChildren =
  StaffAdminWorkspaceRoute._addFileChildren(StaffAdminWorkspaceRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ClientFullscreenRoute: ClientFullscreenRouteWithChildren,
  OrgRoute: OrgRouteWithChildren,
  StaffFullscreenRoute: StaffFullscreenRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  ClientRoute: ClientRouteWithChildren,
  NotFoundRoute: NotFoundRoute,
  UnauthorizedRoute: UnauthorizedRoute,
  ClientLoginRoute: ClientLoginRoute,
  ForgotPasswordSentRoute: ForgotPasswordSentRoute,
  InviteAcceptRoute: InviteAcceptRoute,
  LoginMfaRoute: LoginMfaRoute,
  LoginMfaSetupRoute: LoginMfaSetupRoute,
  ResetPasswordConfirmRoute: ResetPasswordConfirmRoute,
  SsoSlugRoute: SsoSlugRoute,
  ForgotPasswordIndexRoute: ForgotPasswordIndexRoute,
  InviteIndexRoute: InviteIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  ResetPasswordIndexRoute: ResetPasswordIndexRoute,
  VerifyEmailIndexRoute: VerifyEmailIndexRoute,
  StaffAdminPlatformRoute: StaffAdminPlatformRouteWithChildren,
  StaffAdminWorkspaceRoute: StaffAdminWorkspaceRouteWithChildren,
  AuthSsoLandRoute: AuthSsoLandRoute,
  ClientForgotPasswordSentRoute: ClientForgotPasswordSentRoute,
  ClientRegisterSentRoute: ClientRegisterSentRoute,
  ClientForgotPasswordIndexRoute: ClientForgotPasswordIndexRoute,
  ClientOnboardingIndexRoute: ClientOnboardingIndexRoute,
  ClientRegisterIndexRoute: ClientRegisterIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
